<template>
  <div class="bg-white">
    <template  v-if="isPC">
      <div class="product-detail">
        <!-- 未下架 -->
        <template v-if="productStatus === 1 || productStatus === 4">
          <div class="f--c">
            <div :key="item.fullId" v-for="item in categoryTree">
              <span  class="pointer" style="color: #99C41C" @click="jump(item)">{{ item.fllName }}</span>
              <i :key="item.fullId" class="iconfont icon-Frame_2" style="padding:0 4px"></i>
            </div>
            <p class="item-no">{{$t('productDetail.itemNo')}} : {{spuCode}}</p>
          </div>

          <!-- 商品信息 -->
          <div class="product f">
            <div class="left">
              <!-- <div class="shipFrom F" style="font-size: 14px;font-weight: 500;margin: 0 0 12px 20px">
                {{$t('commodity.ProductDetail.ShipFrom')}}
                <template v-if="warehouseList.length">
                  <oss-img src="https://img.kakaclo.com/web-img/countryIcon/zh-CN.png" v-if="warehouseList[0].country === 'CN'" :width="9" :height="6"></oss-img>
                  <oss-img src="https://img.kakaclo.com/web-img/countryIcon/en.png" v-if="warehouseList[0].country === 'US'" :width="9" :height="6"></oss-img>
                  <oss-img src="https://img.kakaclo.com/web-img/countryIcon/Group%202639.png" v-if="warehouseList[0].country === 'GB'" :width="9" :height="6"></oss-img>
                  <oss-img src="https://img.kakaclo.com/web-img/countryIcon/de.png" v-if="warehouseList[0].country === 'DE'" :width="9" :height="6"></oss-img>
                </template>
              </div> -->
              <template v-if="warehouseList.length">
                <div class="shipFrom f--c" style="font-size: 14px;font-weight: 500;margin: 0 0 12px 20px">
                  <div v-if="warehouseList.length === 1" class="warehouse-list">
                    <oss-img :src="handleCountryImg(warehouseList[0].country)" :width="9" :height="6"></oss-img>
                    {{ warehouseList[0].countryCn }}
                  </div>
                  <div v-else-if="warehouseList.length > 1 && $route.query.noChangeWarehouse">
                    <div slot="reference" class="country-warehouse f--c" style="background-color:#f7f7f7">
                      {{$t('commodity.ProductDetail.ShipFrom')}}
                      <oss-img :src="handleCountryImg(warehouseList[selestWarehouse].country)" :width="9" :height="6"></oss-img>
                      <i class="iconfont icon-Frame_2"></i>
                    </div>
                  </div>
                  <el-popover v-else placement="bottom-start" width="240" trigger="click">
                    <div slot="reference" class="country-warehouse pointer f--c">
                      {{$t('commodity.ProductDetail.ShipFrom')}}
                      <oss-img :src="handleCountryImg(warehouseList[selestWarehouse].country)" :width="9" :height="6"></oss-img>
                      <i class="iconfont icon-Frame_2"></i>
                    </div>
                    <div class="warehouse-list">
                      <div v-for="(item, i) in warehouseList" :key="item.country" class="f--c pointer" @click="selestWarehouse = i">
                        <oss-img :src="handleCountryImg(item.country)" :width="9" :height="6"></oss-img>
                        {{ item.countryCn }}
                        <i v-if="i === selestWarehouse" class="iconfont icon-check-line"></i>
                      </div>
                    </div>
                  </el-popover>
                  <dispatch-explain />
                </div>
              </template>
              <div class="f p-r">
                <!-- 小图 -->
                <div class="small-carousel-img">
                  <oss-img v-for="(item, index) in detail.imgUrl" :key="index" :src="item" :width="67" :height="67" class="pointer" @click.native="switchImg(index, 'carousel')" />
                </div>
                <!-- 进度条 -->
                <el-progress :percentage="percentage" color="#2E485B" class="progress"></el-progress>
                <!-- 轮播图 -->
                <section @mouseover="(leftSimilarShow = true)" @mouseleave="(leftSimilarShow = false)">
                  <el-carousel ref="carousel" :autoplay="false" height="546px" direction="vertical" style="width: 352px" @change="carouselChange">
                    <el-carousel-item v-for="(item, index) in detail.imgUrl" :key="index" :name="String(index)">
                        <div class="magnifyingBaseBox" @mouseenter="imgMouseenter(item, index)" @mouseleave="imgMouseleave(item, index)" @mousemove="e => imgMouseMove(e, item, index)" @click="carouselClick(item, index)">
                          <oss-img
                            :src="item"
                            :width="352"
                            :height="546"
                            class="carousel-img" :alt="productName" />
                          <div class="magnifyingBaseBoxMask"></div>
                        </div>
                    </el-carousel-item>
                  </el-carousel>
                  <div class="shopSimilarBtnLeft pointer" @click="shopSimilar" v-if="offsetWidth<=1200">
                    <i class="iconfont icon-photo"></i>
                    {{$t('commodity.ProductDetail.ShopSimilar')}}
                  </div>
                  <div class="discount-sign" v-if="spuInfo.discountType">
                    <img class="flashDiscount" src="https://img.kakaclo.com/web-img/index/Group%202174.png" v-if="spuInfo.discountType === 1" />
                    <span class="noFlashDiscount" v-else>
                      <template v-if="detail.discountRule == 1">-{{detail.discountPercent}}%</template>
                      <template v-if="detail.discountRule == 2">-${{detail.discountFixed}}</template>
                    </span>
                  </div>
                  <!-- 颜色切换 -->
                  <div class="color-img-list f fw-w" style="width: 352px">
                    <div v-for="(item) in colorList" :key="item.id" class="pointer" :class="{'color-actived': item.color === color}" @click="colorChange(item.color)">
                      <oss-img :src="item.colorImg" :width="42" :height="42" />
                    </div>
                  </div>
                  <div class="shopSimilarBtnLeftPc pointer" v-if="leftSimilarShow" @click="shopSimilar">
                    <i class="iconfont icon-photo"></i>
                    {{$t('commodity.ProductDetail.ShopSimilar')}}
                  </div>
                </section>
                <!-- 放大镜展示 -->
                <div id="magnifyingMoveBox">
                  <img :src="magnifyingImgSrc" id="magnifyingImgSrc"/>
                </div>
              </div>
            </div>
            <div class="right">
              <div>
                <div style="max-width: 620px">
                  <p class="sku-name f--c">
                    <el-tooltip v-if="[1].includes(spuInfo.supplierLevel)" effect="dark" :offset="-20" :content="$t('inSrock.supplierRank')" placement="bottom-start">
                      <img :src="require(`@/assets/img/productDetail/supplier_level${spuInfo.supplierLevel}.svg`)" style="margin-right:5px" alt="">
                    </el-tooltip>
                    {{productName}}
                  </p>
                  <div style="color:#8B93A3;font-size:14px;font-weight:400;text-align: right;margin-bottom:12px;"  v-if="spuInfo.discountType">{{ salesVolume }} {{$t('commodity.ProductDetail.Sales')}}</div>
                  <div v-if="spuInfo.discountType" class="discount-price-box f--c f-b">
                    <div class="f--c">
                      <template v-if="userId">
                        <el-tooltip effect="dark" :content="`Wholesale Price ${$store.state.common.currencySymbol}${countCurrencyConversion(detail.afterDiscountAmount)}`" placement="bottom-start">
                          <span class="discount-price"> WSP {{$store.state.common.currencySymbol}}{{detail.afterDiscountAmount | currencyConversion}}</span>
                        </el-tooltip>
                        <span class="original-price">{{$store.state.common.currencySymbol}}{{skuMinPrice | currencyConversion}}</span>
                      </template>
                      <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                        <div class="f--c pointer">WSP
                          <img class="lock" src="@/assets/img/icon/lock1.png" alt="">
                        </div>
                      </el-tooltip>
                    </div>
                    <div class="discountTips">
                      <template v-if="spuInfo.discountType === 1">
                        <template v-if="spuInfo.endTime - currentTime > 0">
                          <div style="font-size: 12px">{{$t('commodity.ProductDetail.EndIn')}}</div>
                          <div>{{ getEndTimeFormat }}</div>
                        </template>
                        <template v-else>{{$t('commodity.ProductDetail.Over')}}</template>
                      </template>
                      <template v-else-if="spuInfo.discountType === 2">
                        <template v-if="detail.discountRule == 1">-{{detail.discountPercent}}%</template>
                        <template v-if="detail.discountRule == 2">-${{detail.discountFixed}}</template>
                      </template>
                      <template v-else>
                        {{spuInfo.discountName}}
                      </template>
                    </div>
                  </div>
                  <div v-else class="price f-b" style="max-width: 620px">
                    <template v-if="userId">
                      <el-tooltip effect="dark" :content="`Wholesale Price ${$store.state.common.currencySymbol}${countCurrencyConversion(skuMinPrice)}`" placement="bottom-start">
                        <div>WSP {{ $store.state.common.currencySymbol }}{{skuMinPrice | currencyConversion}}</div>
                      </el-tooltip>
                    </template>
                    <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                      <div class="f--c pointer">WSP <img class="lock" src="@/assets/img/icon/lock.png" alt=""></div>
                    </el-tooltip>
                    <div style="color:#8B93A3;font-size:16px;font-weight:400">{{salesVolume}} {{$t('commodity.ProductDetail.Sales')}}</div>
                  </div>
                </div>
                <div class="shipToBox">
                  <!-- 渠道 -->
                  <div class="channelName f--c">
                    <el-popover placement="bottom" trigger="click" width="400">
                      <span slot="reference" class="pointer">
                        <template v-if="activatedChannel.agingGrade">
                          <p style="line-height:24px">
                            <i class="el-icon-truck" style="font-size:20px;margin-right:4px"></i>
                            <span style="margin-right:4px">{{ `${activatedChannel.agingGrade} ${$t('commodity.ProductDetail.Shipping')}` }}</span>
                            <i class="el-icon-arrow-right" style="font-size:12px"></i>
                          </p>
                        </template>
                        <template v-else-if="emptyChannel">
                          <p style="color:rgb(139, 147, 163)">{{$t('commodity.ProductDetail.NoLogisticsChannel')}}</p>
                        </template>
                        <template v-else>
                          <span style="font-weight:bold;color:#333">{{ $t('productDetail.pleaseSelected')}}</span>
                          <i class="iconfont icon-jiantou-xuanze" style="color: #747A87;"></i>
                        </template>
                      </span>
                      <ChannelSelectionDialog :channelList.sync="channelList" @change="channelChange" @strategyChange="strategyChange" :termini="termini"></ChannelSelectionDialog>
                    </el-popover>
                  </div>
                  <div class="f">
                    <!-- 收货国家 -->
                    <div class="smallbox shipTo" style="margin-bottom:8px">
                      <div style="margin-bottom: 8px;font-size:14px;font-weight:500">
                        {{$t('commodity.ProductDetail.ShipTo')}}
                      </div>
                      <div class="shipToSelect f--c">
                        <i class="icon-earth-line iconfont"></i>
                        <Select v-model="termini" placeholder="Please Select" :options="shippableCountryList" :field="{key: 'code', value: 'name'}" @change="getFreightList"></Select>
                      </div>
                    </div>
                    <div class="smallbox deliveryTime p-r">
                      <div style="margin-bottom:8px">{{activatedChannel.deliveryTime}}</div>
                      <div style="font-size:12px;color: #747A87;">{{$t('commodity.ProductDetail.Cost')}} ${{activatedChannel.estimatedFreight | money}}</div>
                      <oss-img src="https://img.kakaclo.com/web-img/countryIcon/Group%202584.png" :width="30" :height="16"  style="position: absolute;top: 0;right: 0px"></oss-img>
                    </div>
                  </div>
                </div>
                <div class="f">
                  <span class="iconfont icon-ruler-horizontal-solid" style="margin-right:4px"></span>
                  <span class="view-all-variants pointer" @click="sizeChartVisible = true" style="margin-right:0">{{$t('productDetail.sizeChart')}}</span>
                </div>
                <div class="login-box">
                  <div class="colorBookTable f">
                    <div>
                      <el-table :data="colorBookTable" max-height="495px" style="width: 620px">
                        <el-table-column
                          prop="color"
                          :label="$t('commodity.ProductDetail.Color')"
                          width="144"
                          fixed="left">
                          <template slot-scope="scope">
                            <div class="f--c">
                              <el-image :src="getColorImage(scope.row.color)" style="width: 40px;height: 40px;margin-right: 4px;border-radius: 6px"></el-image>
                              <el-tooltip class="item" effect="dark" :content="scope.row.color" placement="top-start">
                                <p class="f--c ellipsis" style="font-weight: bold;width: 80px;display: inline-block">{{ scope.row.color }}</p>
                              </el-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column v-for="size in sizeCountArr" :key="size" :prop="size" :label="size" align="center" class-name="smallPadding" label-class-name="smallPadding" width="45">
                          <template slot-scope="scope">
                            <el-input
                            v-model="scope.row[size]"
                            :disabled="!productSkuList.some(sku => (sku.size === size && sku.color === scope.row.color && sku.status === 1 && sku.warehouse.some(code => code.warehouseCode ===  warehouseCode) && (sku.warehouse.filter(code => code.warehouseCode === warehouseCode).length && sku.warehouse.filter(code => code.warehouseCode === warehouseCode)[0].stock) )) || scope.row.isHaveMinOrderQuantity || !userId"
                            @input="v => colorNumBlur(v, scope.row, size)"
                            style="width: 35px"></el-input>
                          </template>
                        </el-table-column>
                        <!-- <el-table-column prop="" label=""></el-table-column> -->
                        <el-table-column v-if="colorBookTable.some(e=>e.isHaveMinOrderQuantity)" prop="pack" :label="$t('commodity.ProductDetail.PACK')" width="110" align="center" fixed="right">
                          <template slot-scope="scope">
                            <el-input-number
                            v-model="scope.row.pack"
                            style="width: 100%"
                            class="packInput"
                            :disabled="!scope.row.isHaveMinOrderQuantity || productSkuList.some(sku =>(scope.row.color === sku.color && sku.status !== 1))"
                            :min="0"
                            :max="maxPackNum(scope.row)"></el-input-number>
                          </template>
                        </el-table-column>
                        <el-table-column :label="$t('commodity.ProductDetail.QTY')" align="center" fixed="right" width="100">
                          <template slot-scope="scope">
                            {{ colorPackQTY(scope.row) }}
                          </template>
                        </el-table-column>
                        <el-table-column :label="$t('commodity.ProductDetail.AMT')" align="center" fixed="right" width="120">
                          <template slot-scope="scope">
                            {{ `$ ${colorPackPrice(scope.row)}` }}
                          </template>
                        </el-table-column>
                      </el-table>
                      <!-- 总金额 -->
                      <template v-if="!isSoldOut">
                        <div>
                          <div
                            class="f-b"
                            style="padding:10px 0 10px 20px;background-color:#F9FAFA;margin: 20px 0 20px;"
                            v-if="sizeList.filter(e=>e.stocks[warehouseCode]).length">
                            <div class="pointer" @click="resetSizeNum" style="color:#747A87;">
                              <i class="iconfont icon-refresh-line" style="margin-right:4px"></i>
                              <span>{{$t('commodity.ProductDetail.ResetQty')}}</span>
                            </div>
                            <div class="f">
                              <div style="width: 110px; text-align: center;">{{totalWeight}}</div>
                              <div style="width: 100px; text-align: center;">{{QTYTotal}}</div>
                              <div style="width: 120px; text-align: center;">$ {{packTotalPrice}}</div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="f-c" style="margin-bottom:20px;width: 620px">
                    <template v-if="isSoldOut">
                      <el-button :disabled="true" style="width:100%;background-color:#C4C4C4;color:#fff;height: 45px">{{$t('commodity.ProductDetail.SoldOut')}}</el-button>
                    </template>
                    <template v-else>
                      <!-- <span v-if="addToCartDisabled" class="out-of-stock-tips">{{$t('productDetail.outOfStockTips')}}</span> -->
                      <el-button v-if="addToCartDisabled" :disabled="true" style="width:100%;background-color:#C4C4C4;color:#fff;height: 45px">{{$t('commodity.ProductDetail.SoldOut')}}</el-button>
                      <div v-else>
                        <div style="margin-bottom: 30px">
                          <el-button
                          type="primary"
                          style="min-width: 494px;height:54px"
                          @click="pcAddCart"
                          :disabled="!sizeList.filter(e=>e.stocks[warehouseCode]).length">{{$t('productDetail.addToCart')}}</el-button>
                        </div>
                          <div>
                            <div class="add f-c-c">
                              <div class="pointer f--c" @click="publishClick">
                                <i class="iconfont icon-store-line"></i>
                                <span>{{$t('productDetail.listToStore')}}</span>
                              </div>
                              <div class="line" style="padding: 0 38px;">|</div>
                              <div class="pointer f--c" @click="clickAddToWishList">
                                <i class="iconfont" :class="[isInWishList ? 'icon-shoucang-xuanzhong' : 'icon-shoucang']"></i>
                                <span>{{$t('productDetail.addToWishList')}}</span>
                              </div>
                            </div>
                          </div>
                      </div>
                    </template>
                  </div>
                  <!-- login -->
                  <div v-if="!userId" class="login-box-content f-c-c fd-c">
                    <!-- <div style="margin-bottom:16px">{{ $t('commodity.ProductDetail.SignIn') }}</div> -->
                    <el-button type="primary" @click="isLogin">{{ $t('commodity.ProductDetail.SignInSignUp') }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 已下架 -->
        <template v-else>
          <div class="soldOutProduct">
            <div>
              <img src="@/assets/img/product_empty.svg" alt="">
              <!-- <oss-img :src="offTheShelfImg" :width="150" :height="200" v-if="offTheShelfImg"></oss-img>
              <oss-img src="https://img.kakaclo.com/web-img/index/Group%201717.png" :width="150" :height="200" v-else></oss-img> -->
            </div>
            <!-- <h3 class="font">{{$t('commodity.ProductDetail.SoldOut')}}</h3> -->
            <h3 class="font">{{$t('Index.ProductList.NoProductFound')}}</h3>
          </div>
        </template>
        <SelectStoreToPublish ref="selectStoreToPublish" :colorImg="detail.colorImg"></SelectStoreToPublish>
      </div>

      <div class="product-detail productLevel" style="padding-top: 35px;">
        <custom-product v-for="item in productLevel1" :key="item.kkProductId" :product="item" style="width:155px; height: 280px;" kklocation="productDetailMayLike" reportType="recommend" />
      </div>

      <div class="product-detail">
        <el-tabs v-if="productStatus === 1 || productStatus === 4" v-model="activeName" class="myTabs">
          <el-tab-pane :label="`${$t('productDetail.product')} ${$t('productDetail.detail')}`" name="first">
            <!-- 商品详情 -->
              <div style="padding-right: 50px;">
                <ul style="list-style-type:disc;list-style-position: inside;padding-bottom: 15px;">
                  <li>{{$t('commodity.ProductDetail.Sizing')}}: {{$t('commodity.ProductDetail.TrueToSize')}}</li>
                  <li>{{$t('commodity.ProductDetail.MaterialComposition')}}: {{detail.material}}</li>
                  <li v-for="(value, key) in attributes" :key="key">{{key}}: {{value}}</li>
                </ul>
                <div v-html="description" style="white-space: pre-wrap;width:800px"></div>
              </div>

              <!-- 商品尺码表 -->
              <template v-if="sizeChart.length > 0">
                <div v-for="table in sizeChart" :key="table.sheet_name" style="margin:20px 0" class="detailSizeChart">
                    <div style="font-weight: 600;font-size: 16px;margin-bottom: 20px">{{$t('commodity.ProductDetail.SizeChart')}}</div>
                    <div class="f">
                      <el-radio-group v-model="table.showName" size="mini" class="mychartTab">
                        <el-radio-button :label="$t('commodity.ProductDetail.TableData')">cm</el-radio-button>
                        <el-radio-button :label="$t('commodity.ProductDetail.InchData')">Inch</el-radio-button>
                      </el-radio-group>
                    </div>
                    <div :style="{width: `${table.row.length * 140 + 2}px`}">
                      <div style="max-width:1200px">
                        <el-table :data="table.tableData" v-if="table.showName === 'tableData'" border>
                          <el-table-column v-for="item in table.row" :key="item" :prop="item" :label="item" show-overflow-tooltip  width="140" align="center">
                            <template slot-scope="scope">
                              {{scope.row[item] | toInt}}
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-table :data="table.inchData" v-else border>
                          <el-table-column v-for="item in table.row" :key="item" :prop="item" :label="item" show-overflow-tooltip  width="140" align="center">
                            <template slot-scope="scope">
                              {{ scope.row[item] | toInt}}
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                </div>
              </template>
          </el-tab-pane>
          <el-tab-pane :label="`${$t('productDetail.customerReviews')}(${customerReviewsTotal})`" name="second">
            <!-- 评论区 -->
            <customerReviews :color="color" :size="size" :kkProductId="kkProductId" ref="customerReviews" :colorList="colorList" :sizeList="sizeList" :colorImg="detail.colorImg" @total="v => customerReviewsTotal = v"></customerReviews>
          </el-tab-pane>
          <el-tab-pane :label="`${$t('productDetail.return')} & ${$t('productDetail.refundPolicy')}`" name="third">
            <TermsConditions></TermsConditions>
          </el-tab-pane>
        </el-tabs>
        <!-- 推荐商品 -->
        <div class="recommend-product" style="margin-top: 100px;">
          <div class="f fw-w" style="position:relative; justify-content: space-between;">
            <div class="productLevelTitle"><p>{{ categoryName[1] }}</p></div>
            <div class="productLevelTitle" style="left: 50%; margin-left: 8px;"><p>{{$t('commodity.ProductDetail.WeThinkYoullLoveThese')}}</p></div>
            <custom-product v-for="item in productLevel2" :key="item.kkProductId" :product="item" style="width:155px; height: 280px;" kklocation="productDetailMayLike" reportType="recommend" />
            <custom-product v-for="item in recommendProductList" :key="item.kkProductId" :product="item" style="width:155px; height: 280px;" kklocation="productDetailMayLike" reportType="recommend" />
          </div>
        </div>
        <!-- 变体列表弹窗 -->
        <el-dialog title="All Variants" width="700px" :visible.sync="allVariantsVisible">
          <!-- 仓库 -->
          <div class="ship-from">
            <span>{{$t('productDetail.shipFrom')}} : &nbsp;</span>
            <el-select v-model="dialogWarehouseCode" class="warehouse-select">
              <el-option v-for="item in shippingFromList" :key="item.id" :label="item.name" :value="item.warehouseCode"></el-option>
            </el-select>
          </div>

          <el-table :data="allVariants" style="width: 100%" height="50vh">
            <el-table-column :label="$t('productDetail.image')">
              <template slot-scope="scope">
                <el-image :src="scope.row.imgUrl[0]" :preview-src-list="scope.row.imgUrl" style="width: 48px; height: 48px;" />
              </template>
            </el-table-column>
            <el-table-column prop="color" :label="$t('productDetail.color')"></el-table-column>
            <el-table-column prop="size" :label="$t('productDetail.size')"></el-table-column>
            <el-table-column prop="totalInventory" :label="$t('inSrock.inventory')"></el-table-column>
            <el-table-column prop="price" :label="$t('inSrock.price')"></el-table-column>
            <el-table-column :label="$t('productDetail.action')">
              <template slot-scope="scope">
                <p class="add-to-cart pointer" @click="addCart(dialogWarehouseCode, scope.row.color, scope.row.size)">{{$t('productDetail.addToCart')}}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </div>
    </template>
    <!-- 移动端 -->
    <div v-else style="padding-bottom:2rem">
      <div class="mobile-product-detail">
        <div style="padding: 4vw 4vw 0 4vw">
          <div class="mobile-category-main f swiper-container mobile-banner p-r">
          <div class="swiper-wrapper f">
            <div id="swiper-slide" class="swiper-slide" v-for="(item) in detail.imgUrl" :key="item">
              <oss-img :src="item" :width="345" :height="461" class="mobile-banner-img" />
            </div>
          </div>
          <div class="addToWish f-c-c" @click="clickAddToWishList">
            <i class="iconfont" :class="[isInWishList ? 'icon-shoucang-xuanzhong' : 'icon-shoucang']"></i>
          </div>
          <div class="discount-sign-mt" v-if="spuInfo.discountType">
            <img class="flashDiscount" src="https://img.kakaclo.com/web-img/index/Group%202174.png" v-if="spuInfo.discountType === 1" />
            <span class="noFlashDiscount" v-else>
              <template v-if="detail.discountRule == 1">-{{detail.discountPercent}}%</template>
              <template v-if="detail.discountRule == 2">-${{detail.discountFixed}}</template>
            </span>
          </div>
        </div>
        <!-- color -->
        <div class="color-box" style="margin-top:.2rem">
          <div class="color-img-list f fw-w">
            <div v-for="(item) in colorList" :key="item.id" class="pointer imageBox" :class="{'color-actived': item.color === color}" @click="colorChange(item.color)" style="border-radius:.1rem;border: 1px solid transparent;margin-right:.1rem">
              <oss-img :src="item.colorImg" :width="22" :height="22" style="display: block;border-radius:.1rem" />
            </div>
          </div>
        </div>
        <p class="mobile-product-name">{{productName}}</p>
        <!-- <p class="mobile-product-inventory f-e" v-if="!spuInfo.discountType">
          <span class="gray">{{$t('inSrock.inventory')}}</span>
          {{detail.totalInventory}}
        </p> -->
        <div v-if="spuInfo.discountType" class="mobile-product-price f--c f-b">
          <div>
            <template v-if="userId">
              <el-tooltip effect="dark" :content="`Wholesale Price ${$store.state.common.currencySymbol}${countCurrencyConversion(detail.afterDiscountAmount)}`" placement="bottom-start">
                <span class="discount-price"> WSP {{$store.state.common.currencySymbol}}{{detail.afterDiscountAmount | currencyConversion}}</span>
              </el-tooltip>
              <div class="original-price">{{$store.state.common.currencySymbol}}{{skuMinPrice | currencyConversion}}</div>
            </template>
            <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
              <div class="f--c pointer">WSP <img class="lock" src="@/assets/img/icon/lock1.png" alt=""></div>
            </el-tooltip>
          </div>
          <div class="discountTips">
            <template v-if="spuInfo.discountType === 1">
              <template v-if="spuInfo.endTime - currentTime > 0">
                <div style="font-size: 12px">{{$t('commodity.ProductDetail.EndIn')}}</div>
                <div>{{ getEndTimeFormat }}</div>
              </template>
              <template v-else>{{$t('commodity.ProductDetail.Over')}}</template>
            </template>
            <template v-else-if="spuInfo.discountType === 2">
              <template v-if="detail.discountRule == 1">-{{detail.discountPercent}}%</template>
              <template v-if="detail.discountRule == 2">-${{detail.discountFixed}}</template>
            </template>
            <template v-else>
              {{spuInfo.discountName}}
            </template>
          </div>
        </div>
        <template v-else>
          <el-tooltip v-if="userId" effect="dark" :content="`Wholesale Price ${$store.state.common.currencySymbol}${countCurrencyConversion(skuMinPrice)}`" placement="bottom-start">
            <p class="price" style="font-size:.4rem;font-weight:bold">WSP {{ $store.state.common.currencySymbol }}{{skuMinPrice | currencyConversion}}</p>
          </el-tooltip>
          <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
            <div class="f--c pointer">WSP <img class="lock" src="@/assets/img/icon/lock.png" alt=""></div>
          </el-tooltip>
        </template>
        <div class=" mobile-product-chart f-e f-b" style="margin-top:8px;margin-bottom: 8px">
          <p class="sizeChart" @click="sizeChartVisibleForMT = true">{{$t('commodity.ProductDetail.SizeChart')}}</p>
          <p class="mobile-product-inventory f-e" v-if="!spuInfo.discountType">
            <span class="gray">{{$t('inSrock.inventory')}}</span>
            {{detail.totalInventory}}
          </p>
        </div>
        </div>
        <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);margin-bottom:8px"></div>
        <div style="padding: 0 4vw 0 4vw">
          <!-- 收货国家 -->
          <div class="shipToBoxMt f-b" style="margin-bottom:.2rem;background-color: #F5F7F7;padding: .3rem;">
            <div style="min-width:.4rem" class="f">
              <i class="icon-earth-line iconfont" style="color:#99C41C;font-size:.4rem"></i>
              {{$t('commodity.ProductDetail.ShipTo')}}
            </div>
            <Select v-model="termini" placeholder="Please Select" :options="shippableCountryList" :field="{key: 'code', value: 'name'}" @change="getFreightList"></Select>
          </div>
          <!-- 发货仓库下拉框 -->
          <div style="width:100%;margin-bottom:10px">
            <div class="f f--c">
              <i class="iconfont icon-truck-line" style="color:#99C41C;margin-right:4px"></i>
              <span class="title" style="font-weight:bold;margin-right:4px">{{$t('commodity.ProductDetail.ShipFrom')}}</span>
              <el-popover
                placement="bottom"
                width="100%"
                trigger="click"
                popper-class="warehousePopover">
                <div slot="reference" >
                  <i class="iconfont icon-help pointer"></i>
                  <span style="color:#8B93A3;margin-left:4px;margin-right:8px">:</span>
                </div>
                <div style="border: 10px solid #A075D4;padding: 10px 36px;border-radius:6px">
                  <div class="f f--c">
                    <img src="@/assets/img/languages/zh-CN.png" class="languageImg" style="width:18px;height:14px;margin-right:4px">
                    <span>{{$t('commodity.ProductDetail.China')}}</span>
                  </div>
                  <div style="color:#8B93A3;margin-bottom:10px">{{$t('commodity.ProductDetail.CanSupportMostCountryConfigurations')}}</div>
                  <div class="f f--c">
                    <img src="@/assets/img/languages/en.png" style="width:18px;height:14px;margin-right:4px">
                    <span style="margin-right:12px">US</span>
                    <img src="@/assets/img/languages/UK.png" style="width:18px;height:14px;margin-right:4px">
                    <span style="margin-right:12px">UK</span>
                    <img src="@/assets/img/languages/de.png" style="width:18px;height:14px;margin-right:4px">
                    <span style="margin-right:12px">{{$t('commodity.ProductDetail.Germany')}}</span>
                  </div>
                  <div style="color:#8B93A3;margin-bottom:14px">{{$t('commodity.ProductDetail.OnlyLocalCountryConfigurationsAreSupported')}}</div>
                  <div style="color:#A075D4;padding:8px 12px;border: 1px dashed #A075D4;border-radius: 6px;margin-bottom:10px">{{$t('commodity.ProductDetail.ForExample')}}：{{$t('commodity.ProductDetail.USProductsAreOnlySupportedForShippingToTheUS')}}</div>
                </div>
              </el-popover>
              <!-- <div v-for="(item) in warehouseList" :key="item.warehouseCode" class="pointer" @click="warehouseChange(item)" style="border-radius:6px;color:#8B93A3">
                {{item.countryCn}}
              </div> -->
              <div v-if="warehouseList.length === 1" class="country-warehouse pointer f--c">
                {{ warehouseList[0].countryCn }}
                </div>
              <el-popover v-else placement="bottom-start" width="180" trigger="click">
                <div slot="reference" class="country-warehouse pointer f--c">
                  {{ warehouseList[selestWarehouse].countryCn }}
                  <i class="iconfont icon-Frame_2" style="padding:0 4px"></i>
                </div>
                <div class="warehouse-list">
                  <div v-for="(item, i) in warehouseList" :key="item.country" class="f--c pointer" @click="selestWarehouse = i">
                    <oss-img :src="handleCountryImg(item.country)" :width="9" :height="6"></oss-img>
                    {{ item.countryCn }}
                    <i v-if="i === selestWarehouse" class="iconfont icon-check-line"></i>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
          <!-- shipping/运费 -->
          <div class="shipping-box" v-loading="loadingFreight" style="margin-bottom:8px">
            <!-- 选择渠道 -->
            <template v-if="emptyChannel">
              <p>{{$t('commodity.ProductDetail.NoLogisticsChannel')}}</p>
            </template>
            <div v-else>
              <el-popover placement="bottom" trigger="click" >
                <span slot="reference" class="pointer">
                  <template v-if="activatedChannel.renderName">
                    <p style="line-height:24px">
                      <span style="margin-right:4px">{{$t('commodity.ProductDetail.ShipTo')}} {{terminiName}} </span>
                      <span>{{activatedChannel.renderName}} </span>
                    </p>
                    <p style="line-height:24px">
                      <span>{{$t('commodity.ProductDetail.DeliveryTime')}}</span>
                      <span style="color:#99C41C">{{activatedChannel.deliveryTime}}</span>
                      {{$t('commodity.ProductDetail.Cost')}}
                      <span style="color:#99C41C">${{activatedChannel.estimatedFreight | money}}</span>
                    </p>
                  </template>
                  <template v-else>
                    {{ $t('productDetail.pleaseSelected')}}
                    <i class="iconfont icon-jiantou-xuanze" style="color: #747A87;"></i>
                  </template>
                </span>
                <ChannelSelectionDialog :channelList.sync="channelList" @change="channelChange" @strategyChange="strategyChange" :termini="termini"></ChannelSelectionDialog>
              </el-popover>
            </div>
          </div>
        </div>

        <!-- <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);margin-bottom:8px"></div> -->
        <div>
          <el-collapse v-model="sizeActiveNamesMT">
            <el-collapse-item :title="`${$t('productDetail.product')} ${$t('productDetail.detail')}`" name="detail">
              <!-- 商品详情 -->
              <div style="padding: 4vw 4vw 0 4vw">
                <ul style="list-style-type:disc;list-style-position: inside;padding-bottom: 15px;">
                  <li>{{ $t('commodity.ProductDetail.Sizing')}}: {{ $t('commodity.ProductDetail.TrueToSize')}}</li>
                  <li>{{ $t('commodity.ProductDetail.MaterialComposition')}}: {{detail.material}}</li>
                </ul>
                <div v-html="description" style="white-space: pre-wrap;"></div>
              </div>
            </el-collapse-item>
            <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);"></div>
            <template v-if="sizeChart.length > 0">
              <el-collapse-item :title="table.sheet_name" :name="table.sheet_name" v-for="table in sizeChart" :key="table.sheet_name">
                <div style="padding: 0 4vw 0 4vw">
                  <div class="f-e">
                    <el-radio-group v-model="table.showName" size="mini">
                      <el-radio-button :label="$t('commodity.ProductDetail.TableData')">cm</el-radio-button>
                      <el-radio-button :label="$t('commodity.ProductDetail.InchData')">Inch</el-radio-button>
                    </el-radio-group>
                  </div>
                  <el-table :data="table.tableData" v-if="table.showName === 'tableData'">
                    <el-table-column v-for="item in table.row" :key="item" :label="item" show-overflow-tooltip>
                      <template slot-scope="scope">
                          {{scope.row[item] | toInt}}
                        </template>
                    </el-table-column>
                  </el-table>
                  <el-table :data="table.inchData" v-else>
                    <el-table-column v-for="item in table.row" :key="item" :label="item" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{scope.row[item] | toInt}}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
              <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);"></div>
            </template>
            <el-collapse-item :title="`${$t('productDetail.return')} & ${$t('productDetail.refundPolicy')}`" name="refundPolicy">
              <TermsConditions></TermsConditions>
            </el-collapse-item>
            <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);"></div>
            <el-collapse-item :title="`${$t('productDetail.customerReviews')}(${customerReviewsTotal})`" name="customerReviews">
              <!-- 评论区 -->
              <div style="padding: 0 4vw 0 4vw">
                <customerReviews :color="color" :size="size" :kkProductId="kkProductId" ref="customerReviews" :colorList="colorList" :sizeList="sizeList" :colorImg="detail.colorImg" @total="v => customerReviewsTotal = v"></customerReviews>
              </div>
            </el-collapse-item>
            <div style="width:100%;height:10px;background-color:rgb(245, 247, 247);"></div>
          </el-collapse>
        </div>
        <!-- 推荐商品 -->
        <div class="recommend-product" style="margin: .1rem 0;padding:.2rem">
          <h3 style="margin-bottom:.2rem">{{$t('commodity.ProductDetail.WeThinkYoullLoveThese')}}</h3>
          <div class="f fw-w productList">
            <custom-product v-for="item in recommendProductList" :key="item.kkProductId" :product="item" style="width: 49%;" />
          </div>
        </div>

        <Footer>
          <template v-if="isSoldOut">
            <el-button :disabled="true" style="width:100%;background-color:#C4C4C4;color:#fff">{{$t('commodity.ProductDetail.SoldOut')}}</el-button>
          </template>
          <template v-else>
            <el-button style="width: 100%;" type="primary" @click="mobileShoppingCartVisibleToogle">{{$t('productDetail.addToCart')}}</el-button>
          </template>
        </Footer>

        <!-- 加入购物车弹窗 -->
        <div v-show="mobileShoppingCartVisible" class="mobile-shopping-cart-dialog" @click.self="mobileShoppingCartVisibleToogle">
          <div class="mobile-shopping-cart-dialog-body">
            <oss-img :src="detail.imgUrl ? detail.imgUrl[0] : ''" :width="82" :height="103" class="mobile-product-img" />
            <div class="pointer" @click="resetSizeNum" style="color:#747A87;position:absolute;right:.2rem;top:.4rem">
              <i class="iconfont icon-refresh-line" style="margin-right:4px"></i>
              <span>{{$t('commodity.ProductDetail.ResetQty')}}</span>
            </div>
            <!-- 颜色 -->
            <!-- <p class="mobile-shopping-cart-title">{{$t('productDetail.color')}}:</p>
            <div v-for="(item) in colorList" :key="item.id" class="mobile-color-list" :class="{'color-actived': item.color === color}" @click="colorChange(item.color)">
              <oss-img :src="item.colorImg" :width="42" :height="42" />
            </div> -->

            <!-- 尺码 -->
            <p class="mobile-shopping-cart-title">{{$t('productDetail.size')}}:</p>
            <!-- <div v-for="(item) in sizeList" :key="item.id" class="mobile-size-list" :class="{'color-actived': item.size === size, disable: item.disable}" @click="sizeChange(item)">{{item.size}}</div> -->
            <div v-for="(item) in sizeList" :key="item.id" class="f f-b sizeNewList_mt" @click="sizeChange(item)" style="margin-bottom:.1rem;padding-right:0">
              <div style="width:1rem;font-weight:bold;font-size:.3rem">{{item.size}}</div>
              <div>
                <div style="margin-bottom:.1rem" class="f">
                  <div style="font-size:.3rem; width:1rem;margin-right:.4rem">${{item.afterDiscountAmount || item.price}}</div>
                  <div style="font-size:.3rem; width:1rem">{{item.packageWeight/1000}}kg</div>
                </div>
                <div>
                  <span style="color:#8B93A3;font-size:.3rem; width:2.2rem" v-if="!isSoldOut">{{ `Stock(${item.stocks[warehouseCode].stock} PCS)` }}</span>
                </div>
              </div>
              <template v-if="!isSoldOut">
                <el-input-number v-model="item.num" style="width:2.2rem;height:30px" size="small" :min="0" :max="item.stocks[warehouseCode].stock" :precision="0"></el-input-number>
              </template>
              <template v-else>
                <span style="width:150px;text-align:right">{{$t('commodity.ProductDetail.SoldOut')}}</span>
              </template>
            </div>
            <template v-if="!isSoldOut">
              <div class="f f-c-c" style="width:100%;padding:10px 20px;background-color:#F9FAFA;color:#747A87;margin-bottom:10px;margin-top:1rem">
                <div>
                  {{$t('commodity.ProductDetail.Total')}}:
                  <span style="margin-right:2px;color:red">{{piecesTotal}} </span>
                  {{$t('commodity.ProductDetail.Pieces')}}
                  <span style="color:red;margin-right:4px">$ {{ sizePriceTotal }}</span>
                </div>
              </div>
            </template>
            <template v-if="isSoldOut">
              <el-button :disabled="true" style="width:100%;background-color:#C4C4C4;color:#fff">{{$t('commodity.ProductDetail.SoldOut')}}</el-button>
            </template>
            <template v-else>
              <el-button type="primary" :disabled="addToCartDisabled" style="width: 100%;margin-bottom:.3rem" @click="addCart(warehouseCode, detail.color, detail.size, true)">{{$t('productDetail.addToCart')}}</el-button>
            </template>
          </div>
        </div>
        <!-- 变体列表弹窗 -->
        <el-drawer :title="$t('commodity.ProductDetail.AllVariants')" :visible.sync="allVariantsVisible"  size="100%" :with-header="false">
          <div class="AllVariantsForMobile">
            <div class="f-b closeIcon">
              <span style="font-weight: bold">{{$t('commodity.ProductDetail.AllVariants')}}</span>
              <i class="el-icon-close" @click="allVariantsVisible = false"></i>
            </div>
            <!-- 仓库 -->
            <div class="ship-from f">
              <div>{{$t('productDetail.shipFrom')}} : &nbsp;</div>
              <Select v-model="dialogWarehouseCode" placeholder="Please Select" :options="shippingFromList" :field="{key: 'warehouseCode', value: 'name'}"></Select>
            </div>
            <div class="productList">
              <div>
                <el-checkbox v-model="variantsAllCheck" @change="variantsCheckAllForMobile">{{$t('commodity.ProductDetail.SelectAll')}}</el-checkbox>
              </div>
              <div v-for="(item) in allVariants" :key="item.id" class="mobile-shopping-cart-product p-r f" :class="[+item.stock === 0 ? 'disable-product' : '']">
                <!-- 不能勾选的商品： 库存为0 || 商品下架 -->
                <el-checkbox v-model="item.checked" @change="value=> variantsCheckForMobile(value,item)" style="margin: auto 0;"></el-checkbox>
                <oss-img class="mobile-product-img" :src="item.imgUrl[0]" :width="100" :height="100" />
                <div class="mobile-product-info">
                  <p :class="[+item.status===0 ? 'disable':'']" style="margin-bottom: .2rem">{{`${item.option1.value || 'color'}，${item.option2.value || 'size'}`}}</p>
                  <p>{{$t('commodity.ProductDetail.Inventory')}}:{{ item.totalInventory }}</p>
                </div>
                <div v-if="item.afterDiscountAmount >= 0" class="mobile-shopping-cart-product-price mobile-shopping-cart-product-price-discount">
                  <div>${{item.afterDiscountAmount}}</div>
                  <s>${{item.price}}</s>
                </div>
                <p v-else class="mobile-shopping-cart-product-price">${{item.price}}</p>
              </div>
            </div>
            <div class="bottomBtn f-c-c">
              <el-button type="primary" style="width: 80%;height: 80%" @click="addToBagForMobile">{{$t('commodity.ProductDetail.AddToBag')}}</el-button>
            </div>
          </div>
        </el-drawer>
      </div>
    </div>
    <el-image ref="sizeGuide" :src="sizeGuide" :preview-src-list="[sizeGuide]" style="display: none;" />
    <el-dialog :visible="sizeChartVisible" @close="sizeChartVisible = false" :title="$t('commodity.ProductDetail.SizeChart')">
      <oss-img :src="sizeGuide" :width="400" style="width:100%" v-if="sizeGuide" mType="lfit"></oss-img>
      <template v-else>
        <div v-for="table in sizeChart.slice(0, 1)" :key="table.sheet_name">
          <!-- <div>Size Chart</div> -->
          <div class="f-e">
            <el-radio-group v-model="table.showName" size="mini">
              <el-radio-button :label="$t('commodity.ProductDetail.tableData')">cm</el-radio-button>
              <el-radio-button :label="$t('commodity.ProductDetail.inchData')">Inch</el-radio-button>
            </el-radio-group>
          </div>
          <el-table :data="table.tableData" v-if="table.showName === 'tableData'">
            <el-table-column v-for="item in table.row" :key="item" :prop="item" :label="item" show-overflow-tooltip :width="item === 'Sleeve Length'?110:null" />
          </el-table>
          <el-table :data="table.inchData" v-else>
            <el-table-column v-for="item in table.row" :key="item" :prop="item" :label="item" show-overflow-tooltip :width="item === 'Sleeve Length'?110:null" />
          </el-table>
        </div>
      </template>
    </el-dialog>
    <el-dialog :visible="sizeChartVisibleForMT" @close="sizeChartVisibleForMT = false" width="100%">
      <oss-img :src="sizeGuide" :width="150" style="width:100%"></oss-img>
    </el-dialog>
    <el-dialog :visible="originalImageVisible" @close="originalImageVisible = false" width="1000px">
      <div class="f p-r dialogCarouselBox" style="margin: 0 auto">
        <!-- 轮播图 -->
        <el-carousel ref="carouselDialog" :autoplay="false" height="800px" direction="vertical" style="width: 600px;" @change="carouselChange">
          <el-carousel-item v-for="(item, index) in detail.imgUrl" :key="index" :name="String(index)">
              <oss-img
                :src="item"
                :height="900"
                class="dialogImage" />
          </el-carousel-item>
        </el-carousel>
        <!-- 小图 -->
        <div class="small-carousel-img">
          <oss-img v-for="(item, index) in detail.imgUrl" :key="index" :src="item" :width="67" :height="67" class="pointer" @click.native="switchImg(index, 'carouselDialog')" />
        </div>
        <!-- 进度条 -->
        <el-progress :percentage="percentage" color="#2E485B" class="progress" style="left: 450px"></el-progress>
      </div>
    </el-dialog>
    <addingToBagVue ref="addingToBagVue" :sizePriceTotal="sizePriceTotal" @closeAddDialog="resetSizeNum"></addingToBagVue>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import API from '@/api'
import _ from 'lodash'
import bus from '@/util/bus.js'
import SelectStoreToPublish from '@/components/SelectStoreToPublish.vue'
import Footer from '@/components/mobile/Footer.vue'
import ChannelSelectionDialog from './components/ChannelSelectionDialog.vue'
import Select from './components/Select.vue'
import Product from '@/components/Product.vue'
import customerReviews from './components/customerReviews.vue'
import TermsConditions from './components/return&refund.vue'
import addingToBagVue from './components/addingToBag.vue'
import dayjs from 'dayjs'
import DispatchExplain from './components/dispatchExplain.vue'
// import dialog from 'vant/lib/dialog'
// import 'vant/lib/dialog/style'

export default {
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: 'keywords',
          content: this.meta.keywords
        },
        {
          name: 'description',
          content: this.meta.description
        }
      ]
    }
  },
  components: {
    SelectStoreToPublish,
    ChannelSelectionDialog,
    Select,
    Footer,
    'custom-product': Product,
    customerReviews,
    TermsConditions,
    addingToBagVue,
    DispatchExplain
  },
  data() {
    return {
      meta: {
        title: 'wholesale',
        description: 'Price remain a remarkable 5% to 10% lower than the industry averag1e.',
        keywords: ''
      },
      id: 0,
      warehouse: '',
      imgIndex: 0, // 当前轮播图在第几张
      productNumber: 1,
      productName: '',
      warehouseCode: '', // 发货仓库编码
      termini: '', // 收货国家
      dialogWarehouseCode: '', // 变体弹窗中的仓库code
      color: '',
      size: '',
      kkProductId: '',
      description: '',
      policyDescription: '',
      spuCode: '',
      sizeGuide: '',
      isInWishList: false, // 商品是否加入愿望清单
      allVariantsVisible: false,
      publishVisible: false,
      mobileShoppingCartVisible: false,
      loadingFreight: false,
      recommendProductList: [],
      colorMaterialMap: [],
      colorList: [],
      totalColorList: [], // 全部颜色 内对应的仓库编码
      sizeList: [],
      productSkuList: [],
      shippingFromList: [],
      warehouseList: [], // 发货仓库列表
      shippableCountryList: [], // 可发货国家列表
      channelList: [], // 渠道列表
      sizeChart: [],
      detail: {
        status: 1
      }, // 当前sku详情
      freight: {}, // 运费信息
      activatedChannel: {}, // 当前选中的渠道
      activatedStrategy: {}, // 当前渠道排序策略
      attributes: {},
      variantsAllCheck: false,
      magnifyingImgSrc: undefined, // 放大镜图片
      originalImageVisible: false,
      similarImgList: [],
      similarLoading: false,
      sizeActiveNames: [],
      sizeActiveNamesMT: ['customerReviews', 'detail'],
      sizeChartVisible: false,
      sizeChartVisibleForMT: false,
      activeName: 'first',
      customerReviewsTotal: 0,
      productStatus: 1, // 0下架  1上架
      offTheShelfImg: '',
      emptyChannel: false,
      offsetWidth: document.body.clientWidth,
      categoryTree: [],
      salesVolume: 0,
      spuInfo: {}, // spu信息
      currentTime: dayjs().valueOf(),
      timeInterval: null,
      day: 0,
      time: '0000',
      hours: '00',
      colorBookTable: [],
      totalColorTable: [], // 全部颜色
      leftSimilarShow: false,
      selestWarehouse: 0, // 选中的仓库
      productLevel1: [],
      productLevel2: [],
      categoryName: []
    }
  },
  filters: {
    warehouseCodeHandle(value) {
      if (value.includes('CN')) return 'CN'
      return value
    },
    toInt(value) {
      let type = Object.prototype.toString.call(value).slice(8, -1)
      if (type === 'String') {
        if (value.indexOf('-') !== -1) {
          let arr = value.split('-')
          arr.forEach((e, i) => {
            arr[i] = Math.round(parseFloat(e))
          })
          return arr.join('-')
        }
        return value
      }
      return Math.round(parseFloat(value))
    }
  },
  computed: {
    percentage() {
      const imgList = _.get(this, 'detail.imgUrl', [])
      if (imgList.length === 0) return 0
      return (this.imgIndex + 1) / imgList.length * 100
    },
    allVariants() {
      return this.productSkuList.filter(item => {
        let result = false
        _.forEach(item.warehouse, item => {
          if (this.dialogWarehouseCode === item.warehouseCode) {
            result = true
            return false
          }
        })
        return result
      })
    },
    // 当前国家仓库下的总库存
    countCountryWarehouseStock() {
      let stock = 0
      this.productSkuList.forEach(item => {
        item.warehouse.forEach(t => {
          if (t.warehouseCode === this.warehouseCode) {
            stock += t.stock
          }
        })
      })
      return stock
    },

    /**
     * 当库存为0时，禁止加入购物车
     */
    addToCartDisabled() {
      // if (this.spuInfo.discountType && this.spuInfo.discountType === 1 && this.spuInfo.spikeSoldStock >= this.spuInfo.spikeTotalStock) return true
      return !this.countCountryWarehouseStock
      // return this.detail.totalInventory <= 0
    },
    userId() {
      return this.$store.state.common.userId
    },
    currencySymbol() {
      return this.$store.state.common.currencySymbol
    },
    terminiName() {
      const target = this.shippableCountryList.find(e => e.code === this.termini) || {}
      return target.name
    },
    sizePriceTotal() {
      let haveNum = this.sizeList.filter(e => {
        return e.num && e.stocks[this.warehouseCode]
      })
      return haveNum.reduce((current, next) => {
        if (next.afterDiscountAmount) return current + (next.afterDiscountAmount * 1000) * (next.num * 1000) / 1000000
        return current + (next.price * 1000) * (next.num * 1000) / 1000000
      }, 0).toFixed(2)
    },
    piecesTotal() {
      return this.sizeList.reduce((current, next) => {
        let num = current
        if (next.num && next.stocks[this.warehouseCode]) num += next.num
        return num
      }, 0)
    },
    clientWidth() {
      let width = document.body.clientWidth
      return width
    },
    falshSurplusTime() {
      if (this.spuInfo.endTime - this.currentTime < 0) return '00:00:00'
      return dayjs(this.spuInfo.endTime - this.currentTime).format('HH:mm:ss')
    },
    getEndTimeFormat() {
      return `${this.hours}:${this.time[0]}${this.time[1]}:${this.time[2]}${this.time[3]}`
    },
    skuMinPrice() {
      return this.productSkuList.reduce((current, next) => {
        if (!current) return next.price
        if (next.price < current) return next.price
        return current
      }, null)
    },
    isSoldOut() {
      if (this.spuInfo.discountType && this.spuInfo.spikeSoldStock >= this.spuInfo.spikeTotalStock && this.spuInfo.discountType === 1) return true
      if (this.productStatus !== 1) return true
      return false
    },
    sizeCountArr() {
      return this.productSkuList.reduce((current, next) => {
        if (!current.includes(next.size)) current.push(next.size)
        return current
      }, [])
    },
    QTYTotal() {
      let num = 0
      this.colorBookTable.forEach(item => {
        num += this.colorPackQTY(item)
      })
      return num
    },
    totalWeight() {
      let weight = this.colorBookTable[0].packageWeight
      let totalWeight = 0
      this.colorBookTable.forEach(item => {
        totalWeight += (this.colorPackQTY(item) * weight)
      })
      return `${(totalWeight / 1000).toFixed(2)}kg`
    },
    packTotalPrice() {
      let total = 0
      this.colorBookTable.forEach(item => {
        this.sizeCountArr.forEach(size => {
          if (item.isHaveMinOrderQuantity) {
            total += ((item[size] || 0) * (item.pack || 0) * item.price)
          } else {
            total += ((item[size] || 0) * item.price)
          }
        })
      })
      return total.toFixed(2)
    },
    handleCountryImg() {
      return (country) => {
        switch (country) {
          case 'CN':
            return 'https://img.kakaclo.com/web-img/countryIcon/zh-CN.png'
          case 'US':
            return 'https://img.kakaclo.com/web-img/countryIcon/en.png'
          case 'GB':
            return 'https://img.kakaclo.com/web-img/countryIcon/Group%202639.png'
          case 'DE':
            return 'https://img.kakaclo.com/web-img/countryIcon/de.png'
          default:
            return ''
        }
      }
    }
  },
  watch: {
    warehouseCode: function() {
      // 当仓库改变
      this.getShippableCountryList()
    },
    selestWarehouse(val) {
      this.selestWarehouse = val
      this.warehouseCode = this.warehouseList[this.selestWarehouse].warehouseCode
      this.setDefaultColor()
      this.colorList = _.cloneDeep(this.totalColorList.filter(e => Array.from(e.warehouse).includes(this.warehouseCode)))

      // 移除在这个仓库编码中没有这个颜色的sku。
      let filterColorList = this.colorList.map(item => item.color)
      this.colorBookTable = _.cloneDeep(this.totalColorTable.filter(item => {
        return filterColorList.includes(item.color)
      }))
    }
  },
  created() {
    // if (!this.userId) {
    //   localStorage.setItem('loginRedirection', JSON.stringify({
    //     path: this.$route.path,
    //     query: this.$route.query
    //   }))
    //   this.$store.dispatch('logOut')
    //   return
    // }
    this.getDetailId()
  },
  mounted() {
    this.initSwiper()
    window.onresize = _.throttle(() => {
      this.offsetWidth = document.body.clientWidth
    }, 500)
  },
  destroyed() {
    clearInterval(this.timeInterval)
  },
  methods: {
    // 猜你喜欢 (首页)
    getIndexUserRecs() {
      API.getIndexUserRecs({
        pageNumber: 1,
        pageSize: 5
      }).then(({ data }) => {
        this.recommendProductList = data.list
      })
    },

    isNull() {
      return this.$message.warning(this.$t('Components.Product.DetailHint'))
    },

    getDetailId() {
      API.getSeoBusinessId({
        seoSearchTerm: `/${this.$route.params.menu}/${this.$route.params.param}`,
        type: 3
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (!res.data || !res.data.businessId) {
          this.productStatus = 0
          this.getIndexUserRecs()
          return
        }
        this.meta.title = res.data.seoTitle
        this.meta.description = res.data.seoDescription
        this.meta.keywords = res.data.seoKeyWords

        this.id = res.data.businessId // this.$route.query.id
        this.warehouse = this.$route.query.warehouse || undefined
        this.getCategoryByProduct()
        this.getProductDetail()
        bus.$on('reloadProductDetail', this.reloadProductDetail)
        this.$once('hook:beforeDestroy', () => {
          bus.$off('reloadProductDetail')
        })
        this.timeInterval = setInterval(() => {
          this.currentTime += 1000
        }, 1000)
      })
    },

    initSwiper() {
      this.$nextTick(() => {
        new Swiper('.swiper-container', {
          autoplay: 3000,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true // 修改swiper的父元素时，自动初始化swiper
        })
      })
    },

    getCategoryByProduct() {
      API.getCategoryByProduct(this.id).then(({ data }) => {
        if (data && data.fllName && data.fullId) {
          let arr = []
          let fllName = data.fllName.split('/')
          let fullId = data.fullId.split('/')
          let categoryUrl = data.categoryUrl.split(',')
          fllName.forEach((t, i) => {
            arr.push({ fllName: t, fullId: fullId[i], categoryUrl: categoryUrl[i] })
          })
          this.categoryTree = arr

          this.categoryName = fllName
          this.getItemLevel(fullId[2], 8)
          this.getItemLevel(fullId[1], 4)
        }
      })
    },

    getItemLevel(categoryId, pageSize) {
      let data = {
        'pageSize': pageSize,
        'pageNumber': 1,
        'materialArray': [],
        'minPrice': 0,
        'maxPrice': 200,
        'sortType': 'desc',
        'sortName': pageSize === 8 ? 3 : 1,
        'supplierLevels': [],
        'categoryId': categoryId
      }
      API.getOpenProductList(data).then(({ data }) => {
        if (pageSize === 8) {
          this.productLevel1 = data.list
        } else {
          this.productLevel2 = data.list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getProductDetail() {
      const params = {
        kkProductId: this.id
        // countryCode: this.warehouse
      }
      API.getProductDetail(params).then(result => {
        if (!this.meta.title) this.meta.title = result.data.spuCode
        if (!this.meta.description) this.meta.description = result.data.productName
        const shippingFrom = {}
        this.spuInfo = result.data
        this.productName = result.data.productName
        this.spuCode = result.data.spuCode
        this.kkProductId = result.data.kkProductId
        this.productStatus = result.data.status === undefined ? 1 : result.data.status
        this.offTheShelfImg = result.data.colorImg
        this.salesVolume = result.data.salesVolume
        this.getSimilarProductRecommendList()
        if (result.data.status === 0) return
        result.data.productSkuList.forEach(item => {
          item.option1 = JSON.parse(item.option1)
          item.option2 = JSON.parse(item.option2)
          item.color = item.option1.value
          item.size = item.option2.value
          item.totalInventory = item.warehouse.reduce((count, item) => count + +item.stock, 0) // 总库存：将所有仓库库存累加起来
          // 生成shippingFrom数据
          item.warehouse.forEach(item => {
            shippingFrom[`${item.countryCode}${item.warehouseCode}`] = {
              id: item.id,
              name: `${item.countryCn}-${item.warehouseName}`,
              code: item.countryCode + item.warehouseCode,
              countryCn: item.countryCn,
              countryCode: item.countryCode,
              warehouseName: item.warehouseName,
              warehouseCode: item.warehouseCode,
              warehouseId: item.warehouseId,
              warehouseType: item.warehouseType
            }
          })
        })
        this.productSkuList = result.data.productSkuList
        // 生成需要的格式
        this.productSkuList.forEach(item => {
          const target = this.colorBookTable.find(e => e.color === item.color)
          if (!target) {
            const obj = {
              isHaveMinOrderQuantity: !!item.minOrderQuantity,
              color: item.color,
              [item.size]: item.minOrderQuantity || null,
              pack: 0,
              packageWeight: item.packageWeight,
              price: item.afterDiscountAmount || item.price,
              sizeArr: [item.size]
            }
            let stock = 0
            item.warehouse.forEach(e => {
              if (e.stock > stock) stock = e.stock
            })
            obj[`${item.size}stock`] = stock
            this.colorBookTable.push(obj)
          } else {
            let stock = 0
            item.warehouse.forEach(e => {
              if (e.stock > stock) stock = e.stock
            })
            this.$set(target, [`${item.size}stock`], stock)
            this.$set(target, [item.size], item.minOrderQuantity || null)
            target.sizeArr.push(item.size)
          }
        })
        this.totalColorTable = _.cloneDeep(this.colorBookTable)
        this.shippingFromList = Object.values(shippingFrom)
        this.dialogWarehouseCode = _.get(this.shippingFromList, '0.warehouseCode')
        this.generateWarehouseList()
        const colorList = []
        this.productSkuList.forEach(item => {
          let isHave = colorList.find(e => e.color === item.color)
          if (!isHave) {
            colorList.push({
              colorImg: item.colorImg,
              color: item.option1.value,
              warehouse: item.warehouse.map(e => e.warehouseCode)
            })
          } else {
            isHave.warehouse = new Set([...isHave.warehouse, ...item.warehouse.map(e => e.warehouseCode)])
          }
        })
        this.colorList = colorList
        this.totalColorList = _.cloneDeep(colorList)

        this.colorChange()
        this.sizeGuide = result.data.sizeImagePath
        this.description = result.data.description
        this.policyDescription = result.data.policyDescription
        this.isInWishList = +result.data.collectStatus === 1
        this.generateColorMaterialMap(this.productSkuList)
        this.colorList = this.colorList.filter(e => Array.from(e.warehouse).includes(this.warehouseCode))

        // 移除在这个仓库编码中没有这个颜色的sku。
        let filterColorList = this.colorList.map(item => item.color)
        this.colorBookTable = this.colorBookTable.filter(item => {
          return filterColorList.includes(item.color)
        })

        this.formateSizeChart(result.data.sizeContent)
        this.formateAttributes(result.data.attributesJson)
        this.gtag({
          id: result.data.kkProductId,
          name: result.data.productName,
          price: result.data.productSkuList[0].afterDiscountAmount ? result.data.productSkuList[0].afterDiscountAmount : result.data.productSkuList[0].price
        }, 'view_item')
        const { color, colorImg: imgUrl, kkProductId } = this.detail
        // this.searchProductSimilarImgList({ color, imgUrl, kkProductId })
        this.$refs.customerReviews.setValue({ color: this.color, size: this.size })
        if (!this.color && !this.size && !this.spuCode && !this.productName && this.productStatus) {
          this.$message.error(this.$t('promptText.msg17'))
          return
        }
        // 秒杀商品倒计时
        if (this.spuInfo.discountType && this.spuInfo.discountType === 1) {
          const timer = setInterval(() => {
            const current = new Date().getTime()
            const time = this.spuInfo.endTime - current
            if (time <= 0) {
              this.day = 0
              this.time = '0000'
              return clearInterval(timer)
            }
            const day = parseInt(dayjs.tz(time, 'GMT').format('DD')) - 1
            const timeStr = dayjs.tz(time, 'GMT').format('HHmmss')
            let hours = String(parseInt(timeStr.slice(0, 2)) + day * 24)
            if (hours.length === 1) hours = '0' + hours
            this.hours = hours
            this.time = timeStr.slice(2)
          }, 1000)

          this.$once('hook:beforeDestroy', () => {
            clearInterval(timer)
          })
        }
      })
    },
    //
    handleColorBookTable() {

    },

    formateSizeChart(sizeChartString) {
      try {
        const sizeChart = JSON.parse(sizeChartString)
        sizeChart.forEach(table => {
          const columnLength = table.size ? table.size.length : 0
          const rowLength = (table.size && table.size.length) ? table.size[0].size_value.length : 0
          table.tableData = []
          table.inchData = []// 英尺
          table.showName = 'tableData'// 默认展示厘米表格
          table.row = ['size']
          for (let i = 0; i < columnLength; i++) {
            table.row.push(table.size[i].name)
          }
          for (let i = 0; i < rowLength; i++) {
            const row = {
              size: table.size[0].size_value[i].name
            }
            const inchRow = {
              size: table.size[0].size_value[i].name
            }
            for (let j = 0; j < columnLength; j++) {
              const key = table.size[j].name
              const value = table.size[j].size_value[i].value
              row[key] = value
              // 生成inch表格
              if (['US', 'UK'].includes(key)) {
                inchRow[key] = value
              } else {
                if (!isNaN(+value)) {
                  inchRow[key] = Math.round((value / 2.54) * 100) / 100
                } else {
                  /*
                    95-100 此种数据格式
                  */
                  if (value.includes('-')) {
                    const [min, max] = value.split('-')
                    inchRow[key] = `${Math.round((min / 2.54) * 100) / 100}-${Math.round((max / 2.54) * 100) / 100}`
                  }
                }
              }
            }
            table.tableData.push(row)
            table.inchData.push(inchRow)
          }
        })
        this.sizeChart = sizeChart.filter(e => e.size)
        this.sizeActiveNames = this.sizeChart.map(e => e.sheet_name)
      } catch (error) {
        console.error(error)
      }
    },
    formateAttributes(attributes) {
      try {
        this.attributes = attributes ? JSON.parse(attributes) : {}
      } catch (error) {
        console.error(error)
      }
    },
    getSimilarProductRecommendList() {
      API.getSimilarProductRecommendList({
        pageSize: 4,
        pageNumber: 1
      }, this.kkProductId).then(({ data }) => {
        this.recommendProductList = data.list
      })
    },
    // 根据颜色和尺码，生成发货仓库列表
    generateWarehouseList() {
      const skuList = this.productSkuList
      const map = {}
      skuList.forEach(item => {
        item.warehouse.forEach(item1 => {
          if (map[item1.warehouseCode]) {
            map[item1.warehouseCode]['num'] += 1
          } else {
            item1.num = 1
            map[item1.warehouseCode] = item1
          }
        })
      })

      // // 找出sku数量最多的仓库  一样多就CN_N > CN_S > US > DE > UK
      // const recordSkuNum = {}
      // let mostSkuCountry = ''
      // skuList.forEach(item => {
      //   item.warehouse.forEach(item1 => {
      //     if (!recordSkuNum[item1.countryCode]) {
      //       recordSkuNum[item1.countryCode] = [item.skuCode]
      //     } else {
      //       !recordSkuNum[item1.countryCode].includes(item.skuCode) && recordSkuNum[item1.countryCode].push(item.skuCode)
      //     }
      //   })
      // })
      // Object.keys(recordSkuNum).forEach(code => {
      //   if (!mostSkuCountry) mostSkuCountry = code
      //   if (recordSkuNum[code].length > recordSkuNum[mostSkuCountry].length) mostSkuCountry = code
      // })

      // 展示所有仓库 按sku数量最多的仓库降序
      let warehouseAll = _.sortBy(Object.values(map), (item) => { return -item.num })

      // 2023.9.8 写死删除G006
      warehouseAll = warehouseAll.filter(item => item.country !== 'CN' || (item.country === 'CN' && item.warehouseCode === 'G007'))

      // 相同仓库去重 使用sku变体数量多的仓库
      this.warehouseList = _.uniqBy(warehouseAll, 'country')

      // this.warehouseList = Object.values(map).filter(e => {
      //   // 中国用country字段比对
      //   if (this.warehouse && this.warehouse === 'CN') return e.country === this.warehouse
      //   if (this.warehouse) return e.countryCode === this.warehouse
      //   return e.countryCode === mostSkuCountry
      // })
      // 只展示最多的一个仓库
      // 中国南 中国北 统一为中国
      // this.warehouseList.forEach(e => {
      //   if (e.country === 'CN') {
      //     e.countryCn = 'China'
      //     e.countryCode = 'CN'
      //   }
      // })
      if (this.$route.query.warehouse) {
        this.warehouseList.forEach((item, i) => {
          if (item.country === this.$route.query.warehouse) {
            this.selestWarehouse = i
          }
        })
      } else if (!this.$route.query.warehouse) {
        this.warehouseList.forEach((item, i) => {
          if (item.country === 'US') {
            this.selestWarehouse = i
          }
        })
      } else this.selestWarehouse = 0
      this.warehouseCode = this.warehouseList[this.selestWarehouse].warehouseCode
    },
    generateColorMaterialMap(skuList) {
      const result = {}
      const list = []
      skuList.forEach(item => {
        result[item.color] = item.material
      })
      _.forEach(result, (value, key) => {
        list.push({
          color: key,
          material: value
        })
      })
      const everySame = list.every(item => item.material === list[0].material)
      if (everySame) return
      this.colorMaterialMap = list
    },
    carouselChange(index) {
      this.imgIndex = index
    },
    sizeChange({ size, disable }) {
      if (disable) return
      this.size = size
      this.generateWarehouseList()
      this.selectSku()
    },
    colorChange(color) {
      if (!color) {
        let targetColor = this.productSkuList.find(e => {
          return e.warehouse.some(ee => ee.warehouseCode === this.warehouseCode)
        }).color
        this.color = targetColor
      } else {
        this.color = color
      }
      let productSkuList = this.productSkuList.filter(item => item.option1.value === this.color)
      // 对 size 进行去重
      // productSkuList = _.uniqBy(productSkuList, 'size')
      this.sizeList = productSkuList.map(item => {
        const final = {
          size: item.option2.value,
          disable: item.totalInventory <= 0,
          price: item.price,
          packageWeight: item.packageWeight,
          stocks: {},
          skuCode: item.skuCode,
          kkProductId: item.kkProductId,
          num: 1,
          color: item.color,
          afterDiscountAmount: item.afterDiscountAmount
        }
        item.warehouse.forEach(w => {
          final.stocks[w.warehouseCode] = {
            countryCode: w.countryCode,
            stock: w.stock
          }
        })
        return final
      })
      this.sizeList = this.sizeList.filter(e => {
        return Object.keys(e.stocks).includes(this.warehouseCode)
      })
      /*
        存在相同尺码相同尺寸相同颜色但库存重量skuCode不同的情况
        去重
        相同尺寸中取库存较大一个 若库存一样取重量较小一个
      */
      let sizeMap = this.sizeList.reduce((current, next) => {
        if (current[next.size]) {
          if (current[next.size].stocks[this.warehouseCode].stock < next.stocks[this.warehouseCode].stock) {
            current[next.size] = next
          } else if (current[next.size].stocks[this.warehouseCode].stock === next.stocks[this.warehouseCode].stock) {
            if (current[next.size].stocks[this.warehouseCode].packageWeight > next.stocks[this.warehouseCode].packageWeight) {
              current[next.size] = next
            }
          }
        } else {
          current[next.size] = next
        }
        return current
      }, {})
      this.sizeList = Object.keys(sizeMap).map(size => sizeMap[size])
      const undisableSize = this.sizeList.find(item => !item.disable)
      this.size = undisableSize ? _.get(undisableSize, 'size', '') : this.sizeList[0].size
      // this.generateWarehouseList()
      this.selectSku()
      const { colorImg: imgUrl, kkProductId } = this.detail
      this.searchProductSimilarImgList({ color: this.color, imgUrl, kkProductId })
    },
    switchImg(index, refName) {
      this.$refs[refName].setActiveItem(index)
    },
    // 根据 color 和 size 和 仓库 选择对应的 sku
    selectSku() {
      this.detail = this.getMaximumInventorySku(this.color, this.size)
      if (this.detail.imgUrl.length > 7) this.detail.imgUrl.length = 7
    },
    // 添加购物车
    addCart(warehouseCode, color, size, isShowCartDrawer) {
      const num = isShowCartDrawer ? this.productNumber : 1 // 添加到购物车的商品数量
      const sku = this.getMaximumInventorySku(color || this.detail.color, size || this.detail.size)
      if (!sku) return console.error('没有找到sku')
      if (sku.warehouse.length === 0) return console.error(`sku没有仓库信息：${sku}`)
      const cartParams = {
        cartParams: this.sizeList.filter(e => e.num).map(e => {
          return {
            warehouseCode,
            skuCode: e.skuCode,
            kkProductId: e.kkProductId,
            num: e.num
          }
        })
      }
      if (!cartParams.cartParams.length) {
        this.$message.error(this.$t('promptText.msg18'))
        return
      }
      API.addBatchCart(cartParams).then(result => {
        this.$message.success(this.$t('promptText.msg19'))
        bus.$emit('getCartList')
        if (isShowCartDrawer) {
          bus.$emit('showCartDrawer')
        } else {
          this.$refs.addingToBagVue.show(this.sizeList.filter(e => e.num).map(e => {
            return {
              num: e.num,
              price: e.price
            }
          }))
        }
        if (!this.isPC) this.mobileShoppingCartVisibleToogle()
        this.gtag({
          id: this.detail.kkProductId,
          name: this.productName,
          quantity: num,
          price: this.detail.afterDiscountAmount ? this.detail.afterDiscountAmount : this.detail.price
        }, 'add_to_cart')
        this.rdt('AddToCart', {
          currency: 'USD', itemCount: num, value: this.detail.afterDiscountAmount ? this.detail.afterDiscountAmount : this.detail.price
        })
        this.sizeList.forEach(e => {
          e.num = 1
        })
      }).catch((error) => {
        // this.$message.error(this.$t('promptText.msg20'))
        this.$message.error(error.message)
      })
    },
    pcAddCart() {
      if (!this.isLogin()) return
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_addCartButton_click`,
        value: JSON.stringify({ kkProductId: this.detail.kkProductId })
      })
      const cartParams = []
      const dialogArr = []
      let num = 0
      this.colorBookTable.forEach(item => {
        _.forEach(this.sizeCountArr, size => {
        // this.sizeCountArr.forEach(size => {
          if (!this.sizeCountArr.some(size => +item[size])) return
          const target = this.productSkuList.find(e => e.option1.value === item.color && e.size === size && e.warehouse.some(code => code.warehouseCode === this.warehouseCode))
          if (!target) return
          /**
           * 之前单个仓库逻辑
           * // 去库存最多得仓库
          let warehouseCode = ''
          let maxStock = 0
          target.warehouse.forEach(e => {
            if (e.stock > maxStock) {
              maxStock = e.stock
              warehouseCode = e.warehouseCode
            }
          })
          */
          const params = {
            kkProductId: this.kkProductId,
            num: item.isHaveMinOrderQuantity ? (item.pack ? (item.pack || 0) * (item[size] || 0) : 0) : item[size] || 0, // +(item[size] || 0 * (item.pack || 0)) : item[size] || 0,
            skuCode: target.skuCode,
            warehouseCode: this.warehouseCode // 3.20多仓库逻辑，用选中的仓库
          }
          cartParams.push(params)
          // 弹窗参数
          dialogArr.push({ num: +params.num, price: item.price })
          num += (+params.num)
        })
      })
      if (!num) return this.$message.warning('Please enter the purchase quantity first')
      API.addBatchCart({ cartParams }).then(result => {
        if (result.code !== 10000) return this.$message.error(result.message)
        this.$message.success(this.$t('promptText.msg19'))
        bus.$emit('getCartList')
        this.$refs.addingToBagVue.show(dialogArr)
        this.gtag({
          id: this.detail.kkProductId,
          name: this.productName,
          quantity: num,
          price: this.detail.afterDiscountAmount ? this.detail.afterDiscountAmount : this.detail.price
        }, 'add_to_cart')
        this.rdt('AddToCart', {
          currency: 'USD', itemCount: num, value: this.detail.afterDiscountAmount ? this.detail.afterDiscountAmount : this.detail.price
        })
      }).catch((error) => {
        // this.$message.error(this.$t('promptText.msg20'))
        this.$message.error(error.message)
      })
    },
    // 点击添加到愿望清单，根据当前商品是否在愿望清单，调用删除还是添加接口
    clickAddToWishList() {
      if (!this.isLogin()) return
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_addToFavorite_click`,
        value: JSON.stringify({ kkProductId: this.detail.kkProductId })
      })
      this.isInWishList ? this.deleteFromWishList() : this.addToWishList()
    },
    addToWishList() {
      API.addProductList(this.detail.kkProductId).then(() => {
        this.isInWishList = true
        this.$message.success(this.$t('promptText.msg21'))
        this.rdt('AddToWishlist', {
          currency: 'USD',
          itemCount: 1,
          value: this.detail.afterDiscountAmount ? this.detail.afterDiscountAmount : this.detail.price
        })
      })
    },
    // 从愿望清单删除商品
    deleteFromWishList() {
      API.publishGetProductDelete([this.detail.kkProductId]).then(() => {
        this.isInWishList = false
      })
    },
    reloadProductDetail(id) {
      this.id = id
      this.imgIndex = 0
      this.color = ''
      this.size = ''
      this.dialogWarehouseCode = ''
      this.getProductDetail()
    },
    // 根据颜色和尺码和仓库获取库存最多的sku
    getMaximumInventorySku(color, size) {
      let skuList = this.productSkuList.filter(item => {
        return item.color === color && item.size === size && item.warehouse.some(item => (item.warehouseCode === this.warehouseCode))
      })
      return _.maxBy(skuList, item => item.totalInventory)
    },
    publishClick() {
      if (!this.isLogin()) return
      this.$refs.selectStoreToPublish.show(this.detail.kkProductId)
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_listToStore_click`,
        value: JSON.stringify({ kkProductId: this.detail.kkProductId })
      })
    },
    // 获取运费列表
    getFreightList() {
      // if (+this.detail.packageWeight * +this.productNumber > 30 * 1000) return this.$message.error(this.$t('promptText.msg6'))
      const warehouse = this.detail.warehouse.find(item => item.warehouseCode === this.warehouseCode)
      this.loadingFreight = true
      API.getLogisticsChannel({ warehouses: [{
        warehouseCode: warehouse.warehouseCode,
        termini: this.termini,
        channelGrouping: warehouse.warehouseType,
        warehouseId: warehouse.warehouseId,
        products: [{
          skuCode: this.detail.skuCode,
          quantity: this.productNumber,
          kkProductId: this.detail.kkProductId
        }]
      }] }).then(result => {
        if (_.get(result, 'data.0.code') !== 10000) {
          this.channelList = []
          this.activatedChannel = {}
          this.emptyChannel = true
          return console.error(_.get(result, 'data.0.message'))
        }
        this.emptyChannel = false
        let channelList = _.get(result, 'data.0.data', [])
        // 当物流返回时相同类型的渠道返回了多个时，只取同类型渠道中运费最低的渠道在kaka展示
        channelList = channelList.reduce((current, next) => {
          let index = current.findIndex(e => e.agingGrade === next.agingGrade)
          if (index !== -1) {
            if (current[index].estimatedFreight > next.estimatedFreight) {
              current.splice(index, 1)
              current.push(next)
            }
          } else {
            current.push(next)
          }
          return current
        }, [])
        this.channelList = channelList
        // this.activatedChannel = this.channelList[this.channelList.length > 1 ? 1 : 0]
        // (2023/7/20:物流排序值快的在前面，需求：取快的里最便宜的)
        // this.activatedChannel = this.channelList[0]

        // (2023/8/11: express > standard > expedited, 按这个循序取便宜的)
        if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express') > -1) {
          this.activatedChannel = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'express')]
        } else if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard') > -1) {
          this.activatedChannel = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'standard')]
        } else if (this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited') > -1) {
          this.activatedChannel = this.channelList[this.channelList.findIndex(t => t.agingGrade.toLowerCase() === 'expedited')]
        } else {
          this.activatedChannel = this.channelList[0]
        }
        this.freight = _.minBy(channelList, function(freight) {
          return Number(String(freight.deliveryTime).split('~')[0])
        })
      }).catch(() => {
        this.channelList = []
        this.activatedChannel = {}
        this.emptyChannel = true
        // return console.error(_.get(result, 'data.0.message'))
      }).finally(() => {
        this.loadingFreight = false
      })
    },
    /**
     * 获取可配送国家列表
     */
    getShippableCountryList() {
      const { countryCode } = this.warehouseList.find(e => e.warehouseCode === this.warehouseCode)
      if (['DE', 'US', 'GB'].includes(countryCode)) {
        const shipToMap = {
          US: [{ code: 'US', name: 'United States' }],
          DE: [{ code: 'DE', name: 'Germany' }],
          GB: [{ code: 'GB', name: 'United Kingdom' }]
        }
        this.shippableCountryList = shipToMap[countryCode]
        this.termini = _.get(this.shippableCountryList, '0.code', undefined)
        this.getFreightList()
        return
      }
      API.getSelectList({
        type: 7,
        param: this.warehouseCode
      }).then(result => {
        result.data.sort((a, b) => {
          return a.name.charCodeAt(0) - b.name.charCodeAt(0)
        })
        this.shippableCountryList = result.data
        // 国家列表有美国默认选择美国
        const find = this.shippableCountryList.find(item => item.code === 'US')
        this.termini = find ? 'US' : _.get(this.shippableCountryList, '0.code', undefined)
        this.getFreightList()
      })
    },
    jump(item) {
      // this.$router.push(`/mall/product-list?categoryId=${item.fullId}`)
      this.$router.push(`/product-list/${item.categoryUrl}`)
    },
    channelChange(channel) {
      this.activatedChannel = channel
    },
    strategyChange(strategy) {
      this.activatedStrategy = strategy
    },
    // 定制商品
    customProduct() {
      this.$store.commit('commodity/set', {
        customProduct: {
          productName: this.productName,
          referenceLinking: location.href,
          productImageList: this.detail.imgUrl
        }
      })
      this.$router.push('/commodity/customProduct/add')
    },
    mobileShoppingCartVisibleToogle() {
      if (!this.$store.state.common.userId) {
        this.$store.commit('common/set', {
          selectedKKProductId: this.id
        })
        this.$router.push('/login')
        return
      }
      this.$record({
        eventType: 'click',
        eventId: `${this.$route.meta.pageId}_addCartButton_click`,
        value: JSON.stringify({ kkProductId: this.detail.kkProductId })
      })
      this.mobileShoppingCartVisible = !this.mobileShoppingCartVisible
      document.body.style.overflowY = this.mobileShoppingCartVisible ? 'hidden' : 'auto'
    },
    setDefaultColor() {
      const color = this.$route.query.color
      if (!color) {
        this.colorChange()
        return
      }
      const isExist = this.colorList.find(item => item.color === color)
      if (isExist && ![...isExist.warehouse].includes(this.warehouseCode)) {
        delete this.$route.query.color
        this.colorChange()
        return
      }
      if (isExist) this.colorChange(color)
    },
    variantsCheckForMobile(value, item) {
      this.$set(item, 'checked', value)
      this.variantsAllCheck = this.allVariants.every(e => e.checked)
    },
    variantsCheckAllForMobile() {
      this.allVariants.forEach(e => {
        this.$set(e, 'checked', this.variantsAllCheck)
      })
    },
    addToBagForMobile() {
      const products = this.allVariants.filter(e => e.checked).map(e => {
        return {
          warehouseCode: this.dialogWarehouseCode,
          skuCode: e.skuCode,
          kkProductId: e.kkProductId,
          num: 1
        }
      })
      API.addBatchCart({ cartParams: products }).then(res => {
        this.$message.success(this.$t('promptText.msg19'))
        this.allVariantsVisible = false
      })
    },
    // 增强型电子商务代码
    gtag(data, type) {
      window.gtag('event', type, {
        items: [
          data
        ]
      })
    },
    carouselDbClick() {
      console.log('dblckick')
    },
    carouselClick(item, index) {
      this.originalImageVisible = true
      this.$nextTick(() => {
        this.$refs.carouselDialog.setActiveItem(index)
      })
    },
    imgMouseMove(ev, item, index) {
      const magnifyingBaseBox = document.querySelectorAll('.magnifyingBaseBox')[index]
      const magnifyingBaseMask = magnifyingBaseBox.getElementsByTagName('div')[0]
      const magnifyingMoveBox = document.getElementById('magnifyingMoveBox')
      const magnifyingImg = document.getElementById('magnifyingImgSrc')
      const smallCarouselImg = document.querySelector('.small-carousel-img')
      const elCarousel = document.querySelector('.el-carousel')
      const boxLeft = elCarousel.offsetParent.offsetLeft + smallCarouselImg.clientWidth
      const boxTop = elCarousel.offsetParent.offsetTop
      let L = ev.clientX - boxLeft - magnifyingBaseMask.offsetWidth / 2
      let T = ev.clientY - boxTop - magnifyingBaseMask.offsetHeight / 2
      // 边缘则在盒子起始位置
      if (L < 0) {
        L = 0
      } else if (L > magnifyingBaseBox.offsetWidth - magnifyingBaseMask.offsetWidth) {
        L = magnifyingBaseBox.offsetWidth - magnifyingBaseMask.offsetWidth
      }
      if (T < 0) {
        T = 0
      } else if (T > magnifyingBaseBox.offsetHeight - magnifyingBaseMask.offsetHeight) {
        T = magnifyingBaseBox.offsetHeight - magnifyingBaseMask.offsetHeight
      }
      let scaleX = L / (magnifyingBaseBox.offsetWidth - magnifyingBaseMask.offsetWidth)
      let scaleY = T / (magnifyingBaseBox.offsetHeight - magnifyingBaseMask.offsetHeight)
      magnifyingImg.style.left = (magnifyingMoveBox.clientWidth - magnifyingImg.offsetWidth) * scaleX + 'px'// div3不包含边框的宽
      magnifyingImg.style.top = (magnifyingMoveBox.clientHeight - magnifyingImg.offsetHeight) * scaleY + 'px'
      magnifyingBaseMask.style.left = L + 'px'
      magnifyingBaseMask.style.top = T + 'px'
    },
    imgMouseenter(item, index) {
      const ele = document.querySelectorAll('.magnifyingBaseBoxMask')[index]
      ele.style.display = 'block'
      this.magnifyingImgSrc = item
      const magnifying = document.getElementById('magnifyingMoveBox')
      magnifying.style.display = 'block'
    },
    imgMouseleave(item, index) {
      const ele = document.querySelectorAll('.magnifyingBaseBoxMask')[index]
      ele.style.display = 'none'
      const magnifying = document.getElementById('magnifyingMoveBox')
      magnifying.style.display = 'none'
    },
    // 以图搜图
    searchProductSimilarImgList(data) {
      this.similarLoading = true
      API.searchProductSimilarImgList(data).then(res => {
        this.similarImgList = res.data.imgData
        this.$store.commit('setState', { key: 'productDetailSimilar', value: this.similarImgList })
      }).finally(() => {
        this.similarLoading = false
      })
    },
    shopSimilar() {
      const { color, colorImg: imgUrl, kkProductId } = this.detail
      this.$router.push({
        'path': '/mall/similar',
        query: {
          color,
          imgUrl,
          kkProductId
        }
      })
    },
    // reddit 数据埋点
    rdt(type, data) {
      window.rdt && window.rdt('track', type, data)
    },
    warehouseChange(item) {
      this.warehouseCode = item.warehouseCode
      this.selectSku()
    },
    mtProductNumberChange(way) {
      if (way === 'cut') {
        this.productNumber > 1 && this.productNumber--
      } else {
        this.productNumber < this.detail.totalInventory && this.productNumber++
      }
    },
    showWhichStock(item) {
      return item.stocks.find(e => e.countryCode === this.warehouseCode)
      // this.warehouseCode
    },
    resetSizeNum() {
      this.sizeList.forEach(e => {
        e.num = 0
      })
      this.colorBookTable.forEach(item => {
        if (item.isHaveMinOrderQuantity) {
          item.pack = 0
        } else {
          this.sizeCountArr.forEach(size => {
            item[size] = null
          })
        }
      })
    },
    colorPackQTY(row) {
      let num = 0
      this.sizeCountArr.forEach(size => {
        if (row.isHaveMinOrderQuantity) {
          num += ((row[size] || 0) * (row.pack || 0))
        } else {
          if (row[size]) {
            num += (+row[size])
          }
        }
      })
      return num
    },
    colorPackPrice(row) {
      let num = 0
      this.sizeCountArr.forEach(size => {
        if (row.isHaveMinOrderQuantity) {
          num += ((row[size] || 0) * (row.pack || 0) * row.price)
        } else {
          if (row[size]) {
            num += parseFloat((row[size] || 0) * row.price)
          }
        }
      })
      return num.toFixed(2)
    },
    maxPackNum(row) {
      let totalSize = row.sizeArr.reduce((current, next) => {
        if (!current.includes(next)) current.push(next)
        return current
      }, [])
      let maxPackNum = -1
      totalSize.forEach(size => {
        if (maxPackNum === -1) maxPackNum = Math.floor(row[`${size}stock`] / row[size])
        if (maxPackNum > Math.floor(row[`${size}stock`] / row[size])) maxPackNum = Math.floor(row[`${size}stock`] / row[size])
      })
      return maxPackNum
    },
    colorNumBlur(value, row, size) {
      value = value.replace(/[^\d]/g, '')
      row[size] = value
      this.productSkuList.forEach(item => {
        if (item.color === row.color && item.size === size) {
          item.warehouse.forEach(w => {
            if (w.warehouseCode === this.warehouseCode && +value > w.stock) {
              row[size] = w.stock
              this.$message(this.$t('productDetail.maximum') + w.stock)
            }
          })
        }
      })
      // if (+value > +row[`${size}stock`]) {
      //   row[size] = row[`${size}stock`]
      //   this.$message(this.$t('productDetail.maximum') + row[`${size}stock`])
      // }
      if (row[size] > 9999) row[size] = 9999
    },
    getColorImage(color) {
      let t = this.colorList.find(e => e.color === color) || { colorImg: undefined }
      return t.colorImg
    },
    countCurrencyConversion(value) {
      if (!value || typeof value !== 'number') return value
      let rate = this.$store.state.common.currencyRate * 10000
      return (value * 10000 * rate / 100000000).toFixed(2)
    },
    isLogin() {
      if (!this.userId) {
        localStorage.setItem('loginRedirection', JSON.stringify({
          path: this.$route.path,
          query: this.$route.query
        }))
        this.$store.dispatch('logOut')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.warehouse-list {
  >div {
    position: relative;
    padding-bottom: 10px;
    img {
      margin-right: 10px;
    }
    .icon-check-line {
      position: absolute;
      right: 0;
      color: #99C41C;
    }
  }
  >div:last-child {
    padding-bottom: 0;
  }
}
.shipFrom {
  .country-warehouse {
    border: 1px solid #eee;
    padding: 6px 10px;
    img {
      margin-left: 6px;
      margin-right: 14px;
    }
  }
}

.product-detail{
  max-width: 1400px;
  min-width: 1200px;
  // min-height: calc(100vh - 40px);
  margin: 0 auto;
  padding: 0 50px 20px;

  .crumbs{
    font-size: 14px;
    color: #10141D;
    padding: 15px 0 10px 0;
    i{
      position: relative;
      top: 1.5px;
    }
  }

  .detail-text{
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
    padding-bottom: 16px;
  }

  .item-no{
    font-size: 14px;
    padding: 15px 0;
    color: #8B93A3;
  }
  .recommend-product{
    h3{
      padding: 50px 0 30px 0;
    }
    .productList{
      >div{
        margin-right: 1%;
      }
      >div:nth-of-type(5n) {
        margin-right: 0;
      }
    }
  }
  .soldOutProduct {
    text-align: center;
    padding-top: 100px;
    .font{
      margin-top: 50px;
    }
  }
  .detailSizeChart{

  }
}
.product {
  .left {
    margin-right: 50px;
    .add{
      width: 352px;
      padding-top: 22px;
      span{
        text-decoration-line: underline;
        padding-left: 5px;
      }
    }
    .product-info{
      flex: 1;
      padding-left: 30px;
      .size-guide{
        text-decoration-line: underline;
        color: #10141D;
      }
      .payment-method-img{
        img{
          display: block;
          width: 50px;
        }
      }
    }
    .product-info-key{
      font-size: 14px;
      line-height: 20px;
      color: #747A87;
      padding: 26px 0 4px;
    }
    .product-info-value{
      font-size: 12px;
      line-height: 17px;
      color: #10141D;
    }
    /deep/.el-carousel__indicators{
        right: 320px !important;
    }
    .discount-sign{
      position: absolute;
      top: 12px;
      left: 120px;
      z-index: 999;
      .noFlashDiscount{
        background: #DB2D4C;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
        padding: 0 5px;
        border-radius: 2px;
      }
      .flashDiscount{
        width: 22px;
        height: 26px;
      }
    }
    .color-img-list{
      margin-top: 10px;
        div{
          width: 42px;
          height: 42px;
          margin: 0 12px 12px 0;
          border-radius: 6px;
          overflow: hidden;
        }
        img{
          width: 42px;
          height: 42px;
          object-fit: cover;
          display: block;
          border-radius: .1rem;
        }

      }
  }
  .right {
    flex: 1;
    // max-width: 510px;
    .price{
      font-size: 20px;
      line-height: 28px;
      padding-bottom: 10px;
      font-weight: bold;
    }
    .discount-price-box{
      height: 46px;
      background-image: url('https://img.kakaclo.com/web-img/index/Rectangle%20857.png');
      color: #ffffff;
      padding: 0 12px;
      background-size:100%;
      .discount-price{
        font-weight: 500;
        font-size: 22px;
      }
      .original-price{
        font-weight: 400;
        font-size: 14px;
        padding: 0 15px 0 10px;
        text-decoration: line-through;
      }
      .discount{
        // background: #DB2D4C;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
        padding: 0 5px;
        border-radius: 2px;
      }
      .discountTips{
        text-align: center;
        font-family: 'Poppins' 'PingFang SC' 'Helvetica Neue' 'Helvetica' 'Arial' 'sans-serif';
        font-style: italic;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
      }
    }
    .sku-name{
      font-weight: 500;
      font-size: 16px;
      color: #10141D;
      padding: 10px 0 0 ;
      max-width: 510px;
    }
    .color-box{
      .color-img-list{
        div{
          width: 42px;
          height: 42px;
          margin: 0 12px 12px 0;
          border-radius: 6px;
          overflow: hidden;
        }
        img{
          width: 42px;
          height: 42px;
          object-fit: cover;
          display: block;
          border-radius: .1rem;
        }

      }
    }
    .title {
      min-width: 50px;
      font-size: 16px;
      // color: #747A87;
      white-space: nowrap;
      line-height: 32px;
      font-weight: bold;
    }
    .size-list{
      div{
        // border: 0.5px solid #CDD4DD;
        border-radius: 6px;
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        margin: 0 11px 8px 0;
        font-size: 14px;
        min-width: 70px;
        text-align: center;
      }
    }
    .view-all-variants{
      color: #747A87;
      text-decoration-line: underline;
      font-size: 12px;
      margin-right: 30px;
    }
    .ship-from-select /deep/.el-input__inner, .shipping-select /deep/.el-input__inner{
      border: none;
    }
    .shipping-box{
      width: 380px;
      // border: 0.5px solid #CDD4DD;
      border-radius: 6px;
      padding: 12px 5px 12px 0;
      .freight-info{
        font-size: 14px;
      }
    }
    .qty-input{
      width: 120px;
      margin: 0 15px 0 10px;
    }
    .qty-input /deep/.el-input__inner{
      border-radius: 6px;
    }
    .out-of-stock-tips{
      color: rgb(166, 16, 12);
      font-size: 16px;
    }
    .product-details-text{
      font-weight: 500;
      font-size: 18px;
      color: #10141D;
      padding: 37px 0 10px 0;
    }
    .delivery-information{
      padding: 25px 0;
      text-decoration-line: underline;
    }
    .shipToBox{
      // background-color: #F5F7F7;
      // width: 400px;
      margin: 14px 0;
      // padding: 12px 16px;
      // border-radius: 6px;
      // border: 1px solid #F5F7F7;
      .channelName{
        font-size: 14px;
        margin-bottom: 6px;
      }
      .shipTo{
        margin-right:10px
      }
      .smallbox{
        width:305px;
        height: 66px;
        background-color: #F8F8F8;
        border-radius: 6px;
        padding: 10px 0 10px 16px;
        .shipToSelect{
          .icon-earth-line{
            color: #747A87;
          }
          /deep/.placeholder{
            font-size: 12px;
            color: #747A87;
          }
        }
        .deliveryTime{
          background: url('https://img.kakaclo.com/web-img/countryIcon/Group%202584.png');
        }
      }
    }
    .shipToBoxMt {
      background-color: #F5F7F7;
      width: 400px;
      margin: 14px 0;
      padding: 12px 16px;
      border-radius: 6px;
      // width: 100%;
    }
    .languageImg{
      width: 16px;
      height: 14px;
    }
    .colorBookTable{
      /deep/.el-input__inner{
        border-radius: 0;
        height: 32px;
        line-height: 32px;
        padding: 0;
        text-align: center;
      }
      /deep/.el-input-number__decrease{
        height: 30px;
        line-height: 32px;
        width: 22px;
        background-color: #ffffff;
        top: 2px;
      }
      /deep/.el-input-number__increase{
        width: 22px;
        height: 30px;
        line-height: 32px;
        background-color: #ffffff;
        top: 2px;
      }
      .packInput{
        /deep/.el-input__inner{
          border-radius: 4px !important;
        }
      }
    }

    .login-box {
      position: relative;

      .login-box-content {
        width: 620px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba($color: #fff, $alpha: 0.8);
        z-index: 10;

        /deep/ .el-button--medium {
          padding: 14px 20px;
        }
      }
    }
  }
  .similar {
    width: 280px;
    background-color: #F5F7F7;
    height: 300px;
    .title{
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      margin-top: 24px;
    }
    .imageList {
      padding: 16px;
      height: 210px;
      .oss_img_box{
        width: 76px;
        height: 76px;
        margin-right: 8px;
        margin-bottom: 12px;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .oss_img_box:nth-of-type(3n+1){
        margin-right: 0;
      }
    }
    .shopSimilarBtn {
      border-radius: 6px;
      color: #fff;
      background-color: #000000;
      line-height: 30px;
      width: 130px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
.shopSimilarBtnLeft{
  border-radius: 6px;
  color: #fff;
  background-color: #000000;
  line-height: 30px;
  width: 130px;
  text-align: center;
  margin: 0 auto;
  position: absolute;
  left: 140px;
  top: 14px;
  z-index: 2000;
}
.shopSimilarBtnLeftPc{
  border-radius: 6px;
  color: #fff;
  background-color: #000000;
  line-height: 30px;
  width: 130px;
  text-align: center;
  margin: 0 auto;
  position: absolute;
  left: 120px;
  top: 500px;
  z-index: 2000;
}
#toCarouselBoxPosition{
  position: absolute;
}
.magnifyingBaseBoxMask{
  position: absolute;
  width: 200px;
  height: 200px;
  display: none;
  background: rgba(0, 0, 0, 0.1);
  filter: alpha(opacity=50);
  top: 1px;
  left: 1px;
}
#magnifyingMoveBox {
  width: 700px;
  height: 700px;
  position: absolute;
  top: 0px;
  left: 500px;
  overflow: hidden;
  z-index: 10000;
  display: none;
  background-color: #e2e2e2;
  /deep/.el-image{
    position: absolute;
    left: 0;
    top: 0;
    display: block;
  }
  >img{
    position: absolute;
    left: 0;
    display: block;
    top: 0;
  }
}

.carousel-img{
  width: 352px;
  height: 546px;
  object-fit: cover;
}
.dialogCarouselBox {
  width: 80%;
  margin: 0 auto;
  height: 700px;
  .dialogImage{
    height: 700px;
    object-fit: cover;
    width: 550px;
  }
}

.small-carousel-img{
    min-width: 107px;
    img{
        width: 67px;
        height: 67px;
        display: block;
        margin-bottom: 10px;
        border: 0.5px solid #CDD4DD;
        border-radius: 4px;
        object-fit: cover;
    }
    padding: 0 20px;
}
.progress{
    width: 514px;
    transform: rotate(90deg);
    position: absolute;
    top: 250px;
    left: 200px;
}
.mr5{
  margin-right: 5px;
}
.color-actived{
  border: 1px solid #99C41C!important;
}
.disable{
  color: #c0c4cc;
  background-color: #fff;
  cursor: not-allowed;
}
/deep/.el-progress__text{
    display: none;
}
/deep/.el-progress-bar__outer{
    background-color: #F5F7F7;
    height: 2px!important;
}
.el-dropdown-link{
  width: 150px;
  font-size: 14px;
  text-decoration-line: underline;
  color: #10141D;
  padding: 0 12px 0 0;
}
/deep/.el-tabs__item{
  height: 54px;
  line-height: 54px;
}
/deep/.el-tabs__nav-scroll{
  padding-left: 66px;
}
/deep/.el-tabs__content{
  padding: 20px 66px;
}

// 变体弹窗
.ship-from{
  padding-bottom: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #000000;
}
.warehouse-select{
  width: 260px;
}
.add-to-cart{
  color: #99C41C;
  white-space: nowrap;
}

// 选项卡/shipping
.shipping-row{
  padding-bottom: 15px;
  white-space: nowrap;
  .lable{
    color: #8B93A3;
    padding-right: 12px;
  }
  .lable-r{
    display: inline-block;
    min-width: 140px;
    text-align: right;
    flex-shrink: 0;
  }
  .value{
    color: #10141D;
    padding-right: 30px;
  }
  /deep/.el-input{
    width: 260px;
  }
  /deep/.el-input-group__append{
    border-radius: 0 100px 100px 0;
    background: rgba(153, 196, 28, 0.2);
  }
}
.dialogOssImg {
  width: 100% !important;
}
.myTabs{
  /deep/.el-tabs__item{
    font-weight: bold;
    font-size: 18px;
  }
}
.icon-help:hover{
  color: #A075D4;
}
.title:hover{
  .icon-help{
    color: #A075D4;
  }
}
.sizeNewList {
  // padding-right: 40px;
  /deep/.el-input__inner{
    border-radius: 6px !important;
    color: #99C41C;
    padding-left: 30px;
    padding-right: 30px;
  }
  /deep/.el-input-number__decrease{
    width: 20px !important;
    background-color: #fff !important;
  }
  /deep/.el-input-number__increase{
    background-color: #fff !important;
    width: 20px !important;
  }
}
.sizeNewList_mt{
  width: 100%;
  /deep/.el-input__inner{
    border-radius: 6px !important;
    color: #99C41C;
    padding-left: 30px;
    padding-right: 30px;
  }
  /deep/.el-input-number__decrease{
    width: .6rem !important;
    background-color: #fff !important;
  }
  /deep/.el-input-number__increase{
    background-color: #fff !important;
    width: .6rem !important;
  }
}
.icon-shoucang-xuanzhong{
  color: rgb(166, 16, 12);
}
.icon-shoucang{
  color: black;
}

.lock {
  width: 18px;
  margin-left: 4px;
}

.productLevel {
    display:flex;
    justify-content: space-between;
    position: relative;
  }
  .productLevel a, .productLevelRecommend a {
    color: #10141d;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .productList .price, .productLevel .price {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    white-space: nowrap;
  }
  .productList .sale, .productLevel .sale {
    font-size: 14px;
    font-weight: 400;
    line-height: 142%;
    color: #747a87;
    white-space: nowrap;
  }

  .productLevelRecommend {
    display: flex;
    justify-content: left;
    margin: 0 !important;
    width: 50%;
  }
  .productLevelTitle {
    position: absolute;
    top: -36px;
    font-size: 1.17em;
    font-weight: bold;
  }
</style>
<!-- 移动端样式 -->
<style lang="scss" scoped>
.mobile-product-detail{
  // padding: 4vw 4vw 2rem 4vw;
  .mobile-banner{
    width: 92vw;
    margin: 0 auto;
    position: relative;
    .mobile-banner-img{
      width: 92vw;
      height: 123vw;
      object-fit: cover;
      border-radius: 4px;
    }
    .addToWish {
      position: absolute;
      top: .3rem;
      right: .3rem;
      z-index: 100;
      border-radius: 100%;
      background-color: #fff;
      width: 40px;
      height: 40px;
    }
  }
  .mobile-product-name{
    font-size: .32rem;
    padding-top: .4rem;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .mobile-product-price{
    font-size: .36rem;
    font-weight: 500;
    padding: 0.02rem .3rem 0 .3rem;
    height: 46px;
    background-image: url('https://img.kakaclo.com/web-img/index/Rectangle%20770.png');
    color: #FFFFFF;
    margin-bottom: .2rem;
    background-size: 100%;
    .discount-price {
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
    }
    .original-price {
      font-size: .3rem;
      margin-right: .1rem;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      // line-height: 20px;
      text-decoration: line-through;
    }
    .discount{
        background: #DB2D4C;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
        padding: 0 5px;
        border-radius: 2px;
      }
      .discountTips{
        text-align: center;
        // font-family: 'Poppins' 'PingFang SC' 'Helvetica Neue' 'Helvetica' 'Arial' 'sans-serif';
        font-style: italic;
        font-weight: bold;
        font-size: 14px;
      }
  }
  .mobile-product-inventory{
    font-size: .28rem;
    padding: 0.02rem 0 0 0;
    height: .6rem;
  }
  .mobile-product-chart {
    text-decoration:underline;
    // margin-bottom: 20px;
  }
  .mobile-shipping{
    border: 0.5px solid #CDD4DD;
    border-radius: 6px;
    padding: .26rem;
    margin: .4rem 0 .3rem 0;
    overflow: hidden;
  }
  .mobile-product-detail-title{
    font-size: .36rem;
    font-weight: 500;
    padding-bottom: .28rem;
  }
  .mobile-shopping-cart-dialog{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2001;
    background: rgba(32, 32, 32, 0.6);
    .mobile-shopping-cart-dialog-body{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: white;
      padding: 1.15rem .3rem .3rem .3rem;
      .mobile-product-img{
        width: 1.64rem;
        height: 2.06rem;
        position: absolute;
        top: -1.03rem;
        left: .3rem;
        border: 0.5px solid #B6B6B6;
        border-radius: 6px;
      }
      .mobile-shopping-cart-title{
        color: #747A87;
        font-size: .28rem;
        line-height: .6rem;
      }
      .mobile-color-list{
        display: inline-block;
        width: .84rem;
        height: .84rem;
        margin: 0 .2rem .2rem 0;
        border-radius: 6px;
        overflow: hidden;
        img{
          width: .84rem;
          height: .84rem;
          object-fit: cover;
        }
      }
      .mobile-size-list{
        display: inline-block;
        margin: 0 .2rem .2rem 0;
        padding: .1rem .2rem;
        border: 0.5px solid #CDD4DD;
        border-radius: 6px;
      }
      .mobile-qty{
        padding: .25rem 0 .3rem 0;
      }
      .mobile-qty-input{
        width: 30vw;
      }
      .mobile-qty-input /deep/ .el-input__inner{
        border-radius: 6px;
      }
    }
  }
  .AllVariantsForMobile {
    padding: .1rem .2rem 1rem;
    position: relative;
    .closeIcon {
      font-size: .4rem;
      margin-bottom: .1rem;
    }
    .ship-from {

    }
    .productList {
      .mobile-shopping-cart-product{
        padding: .2rem 0;
        border-bottom: 1px solid #DEDEDE;
        .mobile-product-img{
          flex-shrink: 0;
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 8px;
          object-fit: cover;
          margin: 0 .2rem 0 .1rem;
        }
        .mobile-product-info{
          font-size: .24rem;
          p{
            max-width: 55vw;
          }
          .mobile-product-num{
            padding-top: .16rem;
            .button{
              width: .56rem;
              height: .56rem;
              border: 0.5px solid #B6B6B6;
              border-radius: 100%;
            }
            input{
              font-size: .32rem;
              color: #99C41C;
              text-align: center;
              display: inline-block;
              width: .8rem;
              border: none;
              outline: none;
            }
          }
        }
        .icon-a-delete-bin-6-line5{
          position: absolute;
          right: 0;
          top: .16rem;
          color: #B6B6B6;
        }
        .mobile-shopping-cart-product-price{
          position: absolute;
          right: 0;
          bottom: .3rem;
          font-weight: 600;
          font-size: .32rem;
        }
        .mobile-shopping-cart-product-price-discount{
          bottom: .1rem;
          text-align: right;
          >div{
            color:#A6100C;
            font-size:.32rem;
            line-height:.2rem;
          }
          >s{
            color:#747A87;
            font-size:.24rem;
            font-weight:500;
          }
        }
      }
    }
    .bottomBtn {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1rem;
      background-color: #fff;
    }
  }
  .recommend-product {
    .productList{
      >div:nth-of-type(2n-1) {
        margin-right:2%;
      }
    }
  }
  .commonPadding{
    padding: 4vw 4vw 2rem 4vw;
  }
  /deep/.el-collapse-item__header{
    // border-width: 10px;
    // border-color: rgb(245, 247, 247);
    padding: 0 4vw;
  }
  /deep/.el-collapse{
    border-width: 10px;
    border-color: rgb(245, 247, 247);
    border-bottom: none;
  }
}
.gray{
  color: #747A87
}
.noRoundInput {
  /deep/.el-input__inner{
    border-radius: 0;
  }
}

/** iphonex 适配 */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .mobile-shopping-cart-dialog-body{
    padding-bottom: calc(.3rem + 34px)!important;
  }
}
.numIcon{
      width: .56rem;
      height: .56rem;
      border: 0.5px solid #B6B6B6;
      border-radius: 100%;
}
.discount-sign-mt{
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 999;
      .noFlashDiscount{
        background: #DB2D4C;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
        padding: 0 5px;
        border-radius: 2px;
      }
      .flashDiscount{
        width: 22px;
        height: 26px;
      }
    }
/deep/.el-table__header-wrapper{
  .el-table__cell{
    background-color: rgba(0, 0, 0, 0.02);
  }
}
/deep/.el-table__fixed-header-wrapper{
  .el-table__cell{
    background-color: rgba(0, 0, 0, 0.02);
    color: #10141d;
  }
}
</style>
<style lang="scss">
.warehousePopover {
  padding: 0 !important;
  .popper__arrow::after{
    display: none;
  }
}
.detailSizeChart{
    .is-leaf{
      background-color: #ffffff !important;
      .cell {
        font-size: 16px !important;
        font-weight: 600 !important;
      }
    }
    .cell {
      font-size: 16px !important;
    }
    .mychartTab{
      margin-bottom: 20px;
    }
  }
  .colorBookTable{
    thead{
      .is-leaf{
        .cell{
          font-weight: 600 !important;
        }
      }
    }
  }
  .smallPadding{
      >.cell{
        padding: 0 5px !important;
      }
    }
</style>
